import axios from "axios"
import { useStoreState } from "easy-peasy"
import { useEffect, useRef, useState } from "react"
import { beep } from "./beep.js"
import {
	DOG_EMAIL_SEARCH_URL,
	DOG_LICENSE_ADD_URL,
	DOG_LICENSE_DELETE_URL,
	DOG_LICENSE_UPDATE_URL,
	DOG_NAME_SEARCH_URL,
	DOG_PHONE_SEARCH_URL,
	DOG_RECEIPT_REPORT_URL,
	KENNEL_CERTIFICATE_REPORT_URL,
	DOG_TAG_ASSIGN_URL,
	DOG_TAG_REPLACE_URL,
	DOG_TAG_SEARCH_URL,
	DOG_TAGS_URL,
	DOG_TAXPAYER_LOAD_URL,
	KENNEL_REGISTER_URL,
	KENNEL_REGISTRATIONS_URL,
	RECEIPT_NEXT_URL,
	SHEEP_GOATS_ADD_URL,
	SHEEP_GOATS_DATE_PAID_URL,
	SHEEP_GOATS_READ_URL,
	SHEEP_GOATS_UPDATE_URL,
	TAXPAYER_ADD_URL,
	TAXPAYER_DELETE_URL,
	TAXPAYER_EDIT_URL,
	TRANSACTION_ADD_URL,
} from "./Constants.js"
import ErrorPopup from "./ErrorPopup.js"
import StatusPopup from "./StatusPopup.js"
import {
	cap_Name,
	title_Case,
	strip_Name,
	valid_Address,
	valid_Email,
	valid_Name,
	valid_Num_Addr,
	valid_PhoneNumber,
	valid_state_code,
	valid_Zip5,
} from "./Validate"

const HAIR_COLOR_OPTIONS = [
	"BLACK", "BLACK/TAN", "BLACK/WHITE", "BRINDLE", "BLONDE", "BROWN",
	"BROWN/WHITE", "FAWN", "GRAY", "RED", "TRI-COLOR", "WHITE",
]

const DogTaxPayerFind = () => {
	const d = new Date()
	// Redux
	const firstnameRef = useRef(null)
	const kennelAddInProgress = useRef(false)
	const [focusFirstname, setFocusFirstname] = useState(false)
	const [status, setStatus] = useState("")
	// Fiscal year runs Jul 1 – Jun 30 and is labeled/stored by its START year
	// (FY 2026-2027 = tag_year 2026), matching tag generation/assignment. Before
	// Jul 1 the active fiscal year started the prior calendar year.
	const tagYear =
		d < new Date(d.getFullYear(), 6, 1)
			? d.getFullYear() - 1
			: d.getFullYear()
	const [error, setError] = useState("")
	const [formTaxpayerId, setFormTaxpayerId] = useState()
	const [formLastname, setFormLastname] = useState("")
	const [formFirstname, setFormFirstname] = useState("")
	const [formSearchBy, setFormSearchBy] = useState("")
	const [formEmail, setFormEmail] = useState("")
	const [formPhone, setFormPhone] = useState("")
	const [formNumAddr1, setFormNumAddr1] = useState("")
	const [formStAddr1, setFormStAddr1] = useState("")
	const [formAddr2, setFormAddr2] = useState("")
	const [formCity, setFormCity] = useState("")
	const [formStateCode, setFormStateCode] = useState("")
	const [formZip, setFormZip] = useState("")
	const [formDistrict, setFormDistrict] = useState("")
	const [formNote, setFormNote] = useState("")
	const [formKennelName, setFormKennelName] = useState("")

	const [SB_bgc, setSB_bgc] = useState()
	const [LN_bgc, setLN_bgc] = useState()
	const [FN_bgc, setFN_bgc] = useState()
	const [EM_bgc, setEM_bgc] = useState()
	const [PN_bgc, setPN_bgc] = useState()
	const [NA_bgc, setNA_bgc] = useState()
	const [SA_bgc, setSA_bgc] = useState()
	const [A2_bgc, setA2_bgc] = useState()
	const [CN_bgc, setCN_bgc] = useState()
	const [SC_bgc, setSC_bgc] = useState()
	const [ZP_bgc, setZP_bgc] = useState()

	const [LN_Valid, setLN_Valid] = useState(false)
	const [FN_Valid, setFN_Valid] = useState(false)
	const [SB_Valid, setSB_Valid] = useState(false)
	const [EM_Valid, setEM_Valid] = useState(true)
	const [PN_Valid, setPN_Valid] = useState(true)
	const [NA_Valid, setNA_Valid] = useState(true) // street number optional — empty is allowed
	const [SA_Valid, setSA_Valid] = useState(false)
	const [A2_Valid, setA2_Valid] = useState(true)
	const [CN_Valid, setCN_Valid] = useState(false)
	const [SC_Valid, setSC_Valid] = useState(false)
	const [ZP_Valid, setZP_Valid] = useState(true)

	const [breedSuggestions, setBreedSuggestions] = useState([])
	const [showBreedDropdown, setShowBreedDropdown] = useState(false)
	const [breedHighlightIndex, setBreedHighlightIndex] = useState(-1)

	// dog license
	const [dogs, setDogs] = useState([])
	const [dogId, setDogId] = useState(null)
	const [dogName, setDogName] = useState("")
	const [dogSex, setDogSex] = useState("M")
	const [dogAge, setDogAge] = useState("")
	const [dogBreed, setDogBreed] = useState("")
	const [dogHairColor, setDogHairColor] = useState("")
	const [hairColorCustom, setHairColorCustom] = useState(false)
	// custom mode when explicitly chosen, or when an existing dog's saved color
	// isn't one of the standard options (e.g. loaded for edit)
	const hairColorIsCustom =
		hairColorCustom || (!!dogHairColor && !HAIR_COLOR_OPTIONS.includes(dogHairColor))
	const [dogHairLength, setDogHairLength] = useState("")
	const [dogSize, setDogSize] = useState("")
	const [dogTagNumber, setDogTagNumber] = useState("")
	const [dogCheckNumber, setDogCheckNumber] = useState("")
	const [dogSpayNeuter, setDogSpayNeuter] = useState(false)
	const [dogVicious, setDogVicious] = useState(false)
	const [originalDogVicious, setOriginalDogVicious] = useState(false)
	const [viciousPaidDogIds, setViciousPaidDogIds] = useState(new Set())
	const [dogStatus, setDogStatus] = useState("")
	const [dogFeeType, setDogFeeType] = useState("Active")
	const [kennelNameMissing, setKennelNameMissing] = useState(false)
	const [kennelAddStatus, setKennelAddStatus] = useState("")
	const [tagOverride, setTagOverride] = useState("")
	const [tagOverrideError, setTagOverrideError] = useState("")
	const [tagOverrideInfo, setTagOverrideInfo] = useState("")
	const [dogError, setDogError] = useState("")
	const [dogAddMode, setDogAddMode] = useState(false)
	const [searchError, setSearchError] = useState("")
	const [newDogTagOverrides, setNewDogTagOverrides] = useState(new Map())
	const [replacementDogIds, setReplacementDogIds] = useState(new Set())
	const [renewalDogIds, setRenewalDogIds] = useState(new Set())
	const [receiptError, setReceiptError] = useState("")

	useEffect(() => {
		if (searchError) beep()
	}, [searchError])
	useEffect(() => {
		if (dogError) beep()
	}, [dogError])
	useEffect(() => {
		if (receiptError) beep()
	}, [receiptError])

	// sheep & goats
	const [sgId, setSgId] = useState(null)
	const [sgSheep, setSgSheep] = useState("")
	const [sgGoats, setSgGoats] = useState("")
	const [sgStatus, setSgStatus] = useState("")
	const [sgError, setSgError] = useState("")
	const [sgDatePaid, setSgDatePaid] = useState(null)

	// name search results
	const [searchResults, setSearchResults] = useState([])
	const [showHelp, setShowHelp] = useState(false)
	const [showSgHelp, setShowSgHelp] = useState(false)
	const [showSgLocked, setShowSgLocked] = useState(false)
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
	const [dupMatches, setDupMatches] = useState(null)
	const [taxpayerHasTransactions, setTaxpayerHasTransactions] = useState(false)
	const [showTagOverrideHelp, setShowTagOverrideHelp] = useState(false)
	const [showBreedHelp, setShowBreedHelp] = useState(false)

	// kennel
	const [existingKennelRegistrations, setExistingKennelRegistrations] = useState(0)
	const [showKennelWarning, setShowKennelWarning] = useState(false)

	// receipt
	const [receipt, setReceipt] = useState([])
	const [receiptNumber, setReceiptNumber] = useState("")
	const [printed, setPrinted] = useState(false)
	const [paymentMethod, setPaymentMethod] = useState("Cash")
	useEffect(() => {
		if (paymentMethod === "Cash") setDogCheckNumber("")
	}, [paymentMethod])

	useEffect(() => {
		if (receipt.length > 0 && !receiptNumber) {
			axios.post(RECEIPT_NEXT_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
			}).then(({ data }) => {
				setReceiptNumber(String(data.receipt_number))
			}).catch(() => {})
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [receipt.length])

	// easy-peasy
	const Token = useStoreState((state) => state.Token)
	const DistrictList = useStoreState((state) => state.DistrictList)
	const FeeList = useStoreState((state) => state.FeeList)
	const breeds = useStoreState((state) => state.BreedList)
	const IsDeputy = useStoreState((state) => state.IsDeputy)

	useEffect(() => {
		if (focusFirstname) {
			firstnameRef.current?.focus()
			setFocusFirstname(false)
		}
	}, [focusFirstname])


	const handleLastnameChange = (e) => {
		const val = cap_Name(strip_Name(e.target.value))
		setFormLastname(val)
		if (val.length === 0) {
			setLN_bgc(undefined)
			setLN_Valid(false)
		} else {
			setLN_bgc({})
			setLN_Valid(true)
		}
		setError("")
	}

	const handleFirstnameChange = (e) => {
		const val = cap_Name(strip_Name(e.target.value))
		setFormFirstname(val)
		if (val.length === 0) {
			setFN_bgc(undefined)
			setFN_Valid(false)
		} else {
			setFN_bgc({})
			setFN_Valid(true)
		}
		setError("")
	}
	const handleSearchbyChange = (e) => {
		setFormSearchBy(e.target.value)
		setError("")
	}

	const handleEmailChange = (e) => {
		setFormEmail(e.target.value)
		if (valid_Email(e.target.value)) {
			setEM_bgc({})
			setEM_Valid(true)
		} else {
			if (e.target.value.length === 0) {
				setEM_bgc({})
			} else {
				setEM_bgc({ border: "2px solid red" })
			}
			setEM_Valid(false)
		}
		setError("")
	}

	const handlePhoneChange = (e) => {
		const isDeleting = e.target.value.length < formPhone.length
		let result = valid_PhoneNumber(e.target.value, isDeleting)
		setFormPhone(result[2])
		if (result[0]) {
			setPN_bgc({})
			setPN_Valid(true)
		} else {
			setPN_bgc({ border: "2px solid red" })
			setPN_Valid(false)
		}
		setError("")
	}
	const handleNumAddr1Change = (e) => {
		console.log(e.target.value)
		setFormNumAddr1(e.target.value)
		if (valid_Num_Addr(e.target.value)) {
			setNA_bgc({})
			setNA_Valid(true)
		} else {
			setNA_bgc({ border: "2px solid red" })
			setNA_Valid(false)
		}
		setError("")
	}
	const handleStAddr1Change = (e) => {
		setFormStAddr1(e.target.value.toUpperCase())
		if (valid_Address(e.target.value)) {
			setSA_bgc({})
			setSA_Valid(true)
		} else {
			setSA_bgc({ border: "2px solid red" })
			setSA_Valid(false)
		}
		setError("")
	}
	const handleAddr2Change = (e) => {
		setFormAddr2(e.target.value)
		if (valid_Address(e.target.value)) {
			setA2_bgc({})
			setA2_Valid(true)
		} else {
			setA2_bgc({ backgroundColor: "pink" })
			setA2_Valid(false)
		}
		setError("")
	}
	const handleCityChange = (e) => {
		setFormCity(e.target.value.toUpperCase())
		if (valid_Name(e.target.value)) {
			setCN_bgc({})
			setCN_Valid(true)
		} else {
			setCN_bgc({ border: "2px solid red" })
			setCN_Valid(false)
		}
		setError("")
	}
	const handleStateCodeChange = (e) => {
		setFormStateCode(e.target.value.toUpperCase())
		if (valid_state_code(e.target.value)) {
			setSC_bgc({})
			setSC_Valid(true)
		} else {
			setSC_bgc({ border: "2px solid red" })
			setSC_Valid(false)
		}
		setError("")
	}
	const handleZipChange = (e) => {
		const val = e.target.value
		if (val && !/^[\d-]*$/.test(val)) return
		setFormZip(val)
		if (valid_Zip5(val)) {
			setZP_bgc({})
			setZP_Valid(true)
		} else {
			if (val.length === 0) {
				setZP_bgc({})
			} else {
				setZP_bgc({ border: "2px solid red" })
			}
			setZP_Valid(false)
		}
		setError("")
	}
	const handleDistrictChange = (e) => {
		const name = e.target.value
		setFormDistrict(name)
		if (name) {
			const dist = DistrictList.find((d) => d.name === name)
			if (dist) {
				setFormCity(dist.city || "")
				setCN_Valid(true)
				setCN_bgc({})
				setFormStateCode(dist.state_code || "")
				setSC_Valid(true)
				setSC_bgc({})
				setFormZip(dist.zip || "")
				setFocusFirstname(true)
			}
		}
		setError("")
	}
	const handleNoteChange = (e) => {
		setFormNote(e.target.value)
		setError("")
	}

	function clearPageData() {
		setError("")
		setStatus("")
		setFormTaxpayerId(undefined)
		setFormFirstname("")
		setFormLastname("")
		setFormEmail("")
		setFormPhone("")
		setFormNumAddr1("")
		setFormStAddr1("")
		setFormAddr2("")
		setFormCity("")
		setFormStateCode("")
		setFormZip("")
		setFormDistrict("")
		setFormNote("")
		setFormKennelName("")
		setKennelNameMissing(false)
		setKennelAddStatus("")
		setLN_bgc(undefined)
		setFN_bgc(undefined)
		setEM_bgc(undefined)
		setPN_bgc(undefined)
		setNA_bgc(undefined)
		setSA_bgc(undefined)
		setA2_bgc(undefined)
		setCN_bgc(undefined)
		setSC_bgc(undefined)
		setZP_bgc(undefined)
		setLN_Valid(false)
		setFN_Valid(false)
		setNA_Valid(true) // street number optional — empty is allowed
		setSA_Valid(false)
		setCN_Valid(false)
		setSC_Valid(false)
		setDogs([])
		setNewDogTagOverrides(new Map())
		setReplacementDogIds(new Set())
		setRenewalDogIds(new Set())
		setViciousPaidDogIds(new Set())
		clearDogForm()
		clearSgForm()
		setSearchResults([])
		setExistingKennelRegistrations(0)
		setTaxpayerHasTransactions(false)
		setReceipt([])
		setReceiptNumber("")
		setReceiptError("")
		setPrinted(false)
		setPaymentMethod("Cash")
		setDogCheckNumber("")
	}

	function handleClear() {
		setFormSearchBy("")
		clearPageData()
	}

	function populateTaxpayer(tp) {
		setFormTaxpayerId(tp.id)
		setFormFirstname(tp.first_name)
		setFormLastname(tp.last_name)
		setFormEmail(tp.email)
		setFormPhone(tp.phone)
		setFormNumAddr1(tp.number_addr1)
		setFormStAddr1(tp.street_addr1)
		setFormAddr2(tp.addr2)
		setFormCity(tp.city_name)
		setFormStateCode(tp.state_code)
		setFormZip(tp.zip)
		setFormDistrict(tp.district)
		setFormNote(tp.notes)
		setFormKennelName(tp.kennel_name || "")
		setLN_Valid(true)
		setFN_Valid(true)
		setNA_Valid(true)
		setSA_Valid(true)
		setCN_Valid(true)
		setSC_Valid(true)
	}

	function populateDogList(dogs) {
		setNewDogTagOverrides(new Map())
		setDogs(
			dogs.map((dog) => [
				dog.id,
				dog.tag_year,
				dog.tag_number,
				dog.dog_name,
				dog.sex,
				dog.age,
				dog.breed,
				dog.status,
				dog.hair_color,
				dog.hair_length,
				dog.size,
				dog.spay_neuter,
				dog.vicious,
			]),
		)
		if (dogs.length > 0) {
			const dog = dogs[0]
			setDogId(dog.id)
			setDogTagNumber(dog.tag_number)
			setDogName(dog.dog_name)
			setDogSex(dog.sex)
			setDogAge(dog.age ?? "")
			setDogBreed(dog.breed)
			setDogHairColor(dog.hair_color)
			setHairColorCustom(false)
			setDogHairLength(dog.hair_length)
			setDogSize(dog.size)
			setDogSpayNeuter(dog.spay_neuter)
			setDogVicious(dog.vicious)
			setOriginalDogVicious(dog.vicious ?? false)
			setDogFeeType(dog.status || "Active")
		} else {
			clearDogForm()
		}
	}

	async function fetchSheepGoats(taxpayerId) {
		try {
			const { data: sg } = await axios.post(SHEEP_GOATS_READ_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				taxpayer_id: taxpayerId,
				year: tagYear,
			})
			setSgId(sg.id)
			setSgSheep(sg.sheep_count.toString())
			setSgGoats(sg.goat_count.toString())
			setSgDatePaid(sg.date_paid || null)
			if (sg.date_paid) return { sheep: 0, goats: 0 }
			return { sheep: sg.sheep_count, goats: sg.goat_count }
		} catch (err) {
			if (err.message === "Request failed with status code 404") {
				clearSgForm()
			} else {
				setSgError(err.message)
			}
			return { sheep: 0, goats: 0 }
		}
	}

	async function fetchKennelRegistrations(taxpayerId) {
		try {
			const { data } = await axios.get(KENNEL_REGISTRATIONS_URL, {
				params: {
					login_id: Token.login_id,
					client_id: Token.client_id,
					taxpayer_id: taxpayerId,
					year: tagYear,
				},
			})
			const count = data.count ?? 0
			setExistingKennelRegistrations(count)
			return count
		} catch {
			setExistingKennelRegistrations(0)
			return 0
		}
	}

	async function populateReceipt(dogs, sheepCount, goatCount, kennelRegCount = 0) {
		const rows = []
		// Add Kennel Registration saves the dogs' Kennel status at once, but the
		// registration itself only at Save & Print. A reload in between used to
		// drop the registration and bill each kennel dog the dog fee (Brooke
		// 2026-10-07: $36 for 12 kennel dogs). Untagged current-year kennel dogs
		// beyond the saved registrations' slots belong to a pending one -- rebuild it.
		const untaggedKennel = dogs.filter(
			(d) => !d.tag_number && !(d.tag_year && d.tag_year < tagYear) && d.status === "Kennel",
		).length
		const pendingRegs = Math.ceil(Math.max(0, untaggedKennel - kennelRegCount * 5) / 5)
		for (let i = 1; i <= pendingRegs; i++) {
			const kennelFee = getFee("kennel")
			rows.push({
				type: "kennel_reg",
				item: `Kennel Registration R${kennelRegCount + i}`,
				qty: 1,
				price: kennelFee,
				subtotal: kennelFee,
				registrationNumber: kennelRegCount + i,
				tagCount: 5,
			})
		}
		const freeKennelSlots = (kennelRegCount + pendingRegs) * 5
		let kennelInReceipt = 0
		for (const dog of dogs) {
			if (dog.tag_number) continue
			if (dog.tag_year && dog.tag_year < tagYear) continue
			const status = dog.status || "Active"
			let price
			let registrationNumber
			if (status === "Service Dog") {
				price = 0
			} else if (status === "Kennel") {
				price = kennelInReceipt < freeKennelSlots ? 0 : getFee("dog")
				const pendingSlot = kennelInReceipt - kennelRegCount * 5
				if (pendingSlot >= 0 && price === 0) registrationNumber = kennelRegCount + 1 + Math.floor(pendingSlot / 5)
				kennelInReceipt++
			} else {
				price = getFee("dog")
			}
			const rowType = status === "Kennel" ? "kennel_dog" : "dog"
			rows.push({
				type: rowType,
				item: `Dog - ${dog.dog_name}`,
				status: dog.status,
				breed: dog.breed,
				qty: 1,
				price,
				subtotal: price,
				dogId: dog.id,
				dogName: dog.dog_name,
				registrationNumber,
			})
		}
		if (sheepCount > 0) {
			const price = getFee("sheep")
			rows.push({
				type: "sheep",
				item: "Sheep",
				qty: sheepCount,
				price,
				subtotal: sheepCount * price,
			})
		}
		if (goatCount > 0) {
			const price = getFee("goat")
			rows.push({
				type: "goat",
				item: "Goat",
				qty: goatCount,
				price,
				subtotal: goatCount * price,
			})
		}
		setReceipt(rows)
		setPrinted(false)
		if (rows.length > 0) await fetchReceiptNumber()
	}

	function showSearchError(msg) {
		setSearchError(msg)
	}

	async function handleSearchByKeyDown(e) {
		if (e.key === "F1") {
			e.preventDefault()
			setShowHelp(true)
			return
		}
		if (e.key !== "Enter") return
		e.preventDefault()
		const val = formSearchBy.trim()
		if (!val) return
		setSearchError("")
		setError("")

		// Tag number: digits only, less than 10 digits
		if (/^\d+$/.test(val) && val.length < 10) {
			try {
				const { data } = await axios.post(DOG_TAG_SEARCH_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					tag_number: val,
				})
				// A tag number is reissued to a different dog each year, so this
				// returns every year it was used, newest first. One hit loads that
				// owner straight away; several show the picker, same as a name search.
				if (data.length === 1) {
					await handleSearchResultClick(data[0].id, data[0].dog_id)
				} else {
					clearPageData()
					setSearchResults(data)
				}
			} catch (err) {
				if (err.message === "Request failed with status code 404") {
					showSearchError("Tag not found.")
				} else if (err.message === "Request failed with status code 410") {
					showSearchError("Tag replaced by previous Taxpayer.")
				} else {
					showSearchError(err.message)
				}
			}
			return
		}

		// Phone: exactly 10 digits, or nnn-nnn-nnnn format
		const phoneDigits = val.replace(/\D/g, "")
		if (/^\d{10}$/.test(val) || /^\d{3}-\d{3}-\d{4}$/.test(val)) {
			try {
				const { data } = await axios.post(DOG_PHONE_SEARCH_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					phone: phoneDigits,
				})
				populateTaxpayer(data.taxpayer)
				populateDogList(data.dogs)
				setTaxpayerHasTransactions(data.has_transactions ?? false)
				const [sg2, kr2] = await Promise.all([fetchSheepGoats(data.taxpayer.id), fetchKennelRegistrations(data.taxpayer.id)])
				await populateReceipt(data.dogs, sg2.sheep, sg2.goats, kr2)
			} catch (err) {
				if (err.message === "Request failed with status code 404") {
					showSearchError("Phone not found.")
				} else {
					showSearchError(err.message)
				}
			}
			return
		}

		// Email: contains @
		if (val.includes("@")) {
			try {
				const { data } = await axios.post(DOG_EMAIL_SEARCH_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					email: val,
				})
				populateTaxpayer(data.taxpayer)
				populateDogList(data.dogs)
				setTaxpayerHasTransactions(data.has_transactions ?? false)
				const [sg3, kr3] = await Promise.all([fetchSheepGoats(data.taxpayer.id), fetchKennelRegistrations(data.taxpayer.id)])
				await populateReceipt(data.dogs, sg3.sheep, sg3.goats, kr3)
			} catch (err) {
				if (err.message === "Request failed with status code 404") {
					showSearchError("Email not found.")
				} else {
					showSearchError(err.message)
				}
			}
			return
		}

		// Name: ,FN or LN or LN,FN — fallback for any alpha-containing value
		if (/[a-zA-Z]/.test(val)) {
			const parts = val.split(",")
			const lastName = parts[0].trim()
			const firstName = parts.length > 1 ? parts[1].trim() : ""
			if (!lastName && !firstName) return
			try {
				const { data } = await axios.post(DOG_NAME_SEARCH_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					last_name: lastName,
					first_name: firstName,
				})
				if (data.length === 1) {
					await handleSearchResultClick(data[0].id)
				} else {
					clearPageData()
					setSearchResults(data)
				}
			} catch (err) {
				if (err.message === "Request failed with status code 404") {
					showSearchError("Name not found.")
				} else {
					showSearchError(err.message)
				}
			}
			return
		}
	}

	// dogId is optional: a tag search knows which dog held the tag, so that dog is
	// moved to the front of the list, which is how this page marks the selected one.
	async function handleSearchResultClick(taxpayerId, dogId) {
		try {
			const { data } = await axios.post(DOG_TAXPAYER_LOAD_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				taxpayer_id: taxpayerId,
			})
			populateTaxpayer(data.taxpayer)
			const idx = dogId ? data.dogs.findIndex((d) => d.id === dogId) : -1
			const dogs =
				idx > 0
					? [data.dogs[idx], ...data.dogs.filter((_, i) => i !== idx)]
					: data.dogs
			populateDogList(dogs)
			setTaxpayerHasTransactions(data.has_transactions ?? false)
			const [sg, kr] = await Promise.all([fetchSheepGoats(taxpayerId), fetchKennelRegistrations(taxpayerId)])
			await populateReceipt(dogs, sg.sheep, sg.goats, kr)
			setSearchResults([])
		} catch (err) {
			if (err.message === "Request failed with status code 404") {
				showSearchError("Taxpayer not found.")
			} else {
				showSearchError(err.message)
			}
		}
	}

	async function handleTaxpayerDelete() {
		try {
			await axios.post(TAXPAYER_DELETE_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				taxpayer_id: formTaxpayerId,
			})
			setShowDeleteConfirm(false)
			handleClear()
		} catch (err) {
			setShowDeleteConfirm(false)
			const det = err.response?.data?.detail
			setError(Array.isArray(det) ? det.map((d) => d.msg).join("; ") : (det || err.message))
		}
	}

	function handleTaxpayerSaveError(err) {
		setStatus("")
		if (err.message === "Request failed with status code 401") {
			setError("Timeout")
		} else if (err.response?.status === 409) {
			const detail = err.response.data?.detail
			if (detail?.reason === "possible_duplicate") {
				// Soft duplicate guard tripped — offer the match(es) instead of erroring
				setDupMatches(detail.matches || [])
			} else if (detail === "taxpayer_email_key") {
				setError(`Duplicate email: ${formEmail} is already on file for another taxpayer.`)
			} else {
				setError("Duplicate value — record already exists.")
			}
		} else if (err.response?.data?.detail) {
			const detail = err.response.data.detail
			const msg = Array.isArray(detail)
				? detail
						.map((d) => `${d.loc?.slice(1).join(".")}: ${d.msg}`)
						.join(" | ")
				: JSON.stringify(detail)
			setError(msg)
		} else {
			setError(err.message)
		}
	}

	// force=true means the deputy clicked "Add anyway" past the duplicate warning
	async function submitAddTaxpayer(force) {
		setStatus("submitting")
		setError("")
		try {
			const { data } = await axios.post(TAXPAYER_ADD_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				first_name: formFirstname,
				last_name: formLastname,
				email: formEmail,
				phone: formPhone,
				number_addr1: formNumAddr1,
				street_addr1: formStAddr1,
				addr2: formAddr2,
				cityname: formCity,
				state_code: formStateCode,
				zip: formZip,
				district: formDistrict,
				note: formNote,
				kennel_name: formKennelName,
				force,
			})
			setFormTaxpayerId(data.taxpayer_id)
			setFormNumAddr1(data.number_addr1)
			setFormStAddr1(data.street_addr1)
			setFormAddr2(data.addr2)
			setFormCity(data.cityname)
			setFormStateCode(data.state_code)
			setFormZip(data.zip)
			setSearchResults([])
			setDupMatches(null)
			setDogAddMode(true)
			setStatus("success")
			setTimeout(() => setStatus(""), 2000)
		} catch (err) {
			handleTaxpayerSaveError(err)
		}
	}

	async function handleTaxpayerSave(e) {
		e.preventDefault()
		if (!formTaxpayerId) {
			await submitAddTaxpayer(false)
			return
		}
		setStatus("submitting")
		setError("")
		try {
			const { data: editData } = await axios.put(TAXPAYER_EDIT_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				id: formTaxpayerId,
				lastname: formLastname,
				firstname: formFirstname,
				email: formEmail,
				phone: formPhone,
				number_addr1: formNumAddr1,
				street_addr1: formStAddr1,
				addr2: formAddr2,
				cityname: formCity,
				statecode: formStateCode,
				zip: formZip,
				district: formDistrict,
				note: formNote,
				kennel_name: formKennelName,
			})
			setFormNumAddr1(editData.number_addr1)
			setFormStAddr1(editData.street_addr1)
			setFormAddr2(editData.addr2)
			setFormCity(editData.cityname)
			setFormStateCode(editData.state_code)
			setFormZip(editData.zip)
			setStatus("success")
			setTimeout(() => setStatus(""), 2000)
		} catch (err) {
			handleTaxpayerSaveError(err)
		}
	}

	function clearDogForm() {
		setDogId(null)
		setDogTagNumber("")
		setDogName("")
		setDogSex("M")
		setDogAge("")
		setDogBreed("")
		setDogHairColor("")
		setHairColorCustom(false)
		setDogHairLength("")
		setDogSize("")
		setDogSpayNeuter(false)
		setDogVicious(false)
		setDogFeeType("Active")
		setOriginalDogVicious(false)
		setTagOverride("")
		setTagOverrideError("")
		setTagOverrideInfo("")
		setDogError("")
		setDogAddMode(false)
	}

	function handleDogClear() {
		clearDogForm()
		setDogAddMode(true)
	}

	function clearSgForm() {
		setSgId(null)
		setSgSheep("")
		setSgGoats("")
		setSgError("")
		setSgDatePaid(null)
	}

	async function handleSgSave() {
		setSgStatus("submitting")
		setSgError("")
		const sheep = parseInt(sgSheep) || 0
		const goats = parseInt(sgGoats) || 0
		try {
			if (sgId === null) {
				const { data } = await axios.post(SHEEP_GOATS_ADD_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					taxpayer_id: formTaxpayerId,
					year: tagYear,
					sheep_count: sheep,
					goat_count: goats,
				})
				setSgId(data.id)
			} else {
				await axios.put(SHEEP_GOATS_UPDATE_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					id: sgId,
					year: tagYear,
					sheep_count: sheep,
					goat_count: goats,
				})
			}
			const willHaveRows = sheep > 0 || goats > 0
			if (willHaveRows && receipt.length === 0) await fetchReceiptNumber()
			if (sheep > 0) upsertReceiptRow("sheep", "Sheep", sheep, getFee("sheep"))
			else removeReceiptRow("sheep")
			if (goats > 0) upsertReceiptRow("goat", "Goat", goats, getFee("goat"))
			else removeReceiptRow("goat")
			setSgStatus("success")
			setTimeout(() => setSgStatus(""), 2000)
		} catch (err) {
			setSgStatus("")
			setSgError(err.message)
		}
	}

	function getFee(itemType) {
		if (!FeeList || FeeList.length === 0) return 0
		const colMap = { dog: 3, sheep: 4, goat: 5, kennel: 6, vicious: 9, lost_tag: 11 }
		const col = colMap[itemType]
		const sorted = [...FeeList].sort((a, b) => {
			const ya = parseInt(String(a[13]).substring(0, 4))
			const yb = parseInt(String(b[13]).substring(0, 4))
			return yb - ya
		})
		const match =
			sorted.find((f) => parseInt(String(f[13]).substring(0, 4)) === tagYear) ||
			sorted[0]
		if (!match) return 0
		return Number(match[col]) / 100
	}

	async function printReceiptReport(rcptNumber) {
		const url = `${DOG_RECEIPT_REPORT_URL}?client_id=${Token.client_id}&receipt_number=${rcptNumber}`
		const { data: html } = await axios.get(url, { responseType: "text" })
		const iframe = document.createElement("iframe")
		iframe.style.cssText = "position:fixed;width:0;height:0;border:0;"
		document.body.appendChild(iframe)
		iframe.contentDocument.open()
		iframe.contentDocument.write(html)
		iframe.contentDocument.close()
		iframe.contentWindow.focus()
		iframe.contentWindow.print()
		setTimeout(() => document.body.removeChild(iframe), 1000)
	}

	async function printKennelCertificate(kennelName, year) {
		const url = `${KENNEL_CERTIFICATE_REPORT_URL}?client_id=${Token.client_id}&kennel_name=${encodeURIComponent(kennelName)}&year=${year}`
		const { data: html } = await axios.get(url, { responseType: "text" })
		const iframe = document.createElement("iframe")
		iframe.style.cssText = "position:fixed;width:0;height:0;border:0;"
		document.body.appendChild(iframe)
		iframe.contentDocument.open()
		iframe.contentDocument.write(html)
		iframe.contentDocument.close()
		iframe.contentWindow.focus()
		iframe.contentWindow.print()
		setTimeout(() => document.body.removeChild(iframe), 1000)
	}

	async function fetchReceiptNumber() {
		if (receiptNumber) return receiptNumber
		try {
			const { data } = await axios.post(RECEIPT_NEXT_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
			})
			const num = String(data.receipt_number)
			setReceiptNumber(num)
			return num
		} catch (err) {
			setError(err.message)
			return null
		}
	}

	function upsertReceiptRow(type, item, qty, price) {
		const subtotal = qty * price
		setReceipt((prev) => {
			const idx = prev.findIndex((r) => r.type === type)
			const row = { type, item, qty, price, subtotal }
			if (idx >= 0) {
				const updated = [...prev]
				updated[idx] = row
				return updated
			}
			return [...prev, row]
		})
	}

	function removeReceiptRow(type) {
		setReceipt((prev) => prev.filter((r) => r.type !== type))
	}

	async function handleSaveAndPrint() {
		setReceiptError("")
		try {
			const currentReceiptNumber = receiptNumber || await fetchReceiptNumber()
			if (!currentReceiptNumber) throw new Error("Could not obtain a receipt number.")
			// Assign tag numbers to all dogs in the receipt that don't yet have a tag number
			const tagMap = {}
			// Merge session overrides with any override currently shown in the form
			const allOverrides = new Map(newDogTagOverrides)
			if (dogId !== null && tagOverride) allOverrides.set(dogId, tagOverride)
			const untaggedDogIds = receipt
				.filter((r) => r.type === "dog" || r.type === "kennel_dog")
				.map((r) => r.dogId)
				.filter(
					(id) =>
						!renewalDogIds.has(id) && !dogs.find((d) => d[0] === id && d[2]),
				)
			let unusedOverride = tagOverride || null
			for (const dogId of untaggedDogIds) {
				const assignRequest = {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_ids: [dogId],
					tag_year: tagYear,
				}
				const override = allOverrides.get(dogId) || unusedOverride
				if (override) {
					assignRequest.tag_number = parseInt(override, 10)
					if (!allOverrides.has(dogId)) unusedOverride = null
				}
				try {
					const { data: assigned } = await axios.post(
						DOG_TAG_ASSIGN_URL,
						assignRequest,
					)
					tagMap[dogId] = assigned.tags[0].tag_number
				} catch (tagErr) {
					const detail = tagErr.response?.data?.detail
					throw new Error(detail || tagErr.message || "Tag assignment failed")
				}
			}
			// Process tag replacements
			for (const rDogId of replacementDogIds) {
				const replaceRequest = {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_id: rDogId,
					tag_year: tagYear,
				}
				const override = allOverrides.get(rDogId)
				if (override) replaceRequest.tag_number = parseInt(override, 10)
				try {
					const { data: replaced } = await axios.post(
						DOG_TAG_REPLACE_URL,
						replaceRequest,
					)
					tagMap[rDogId] = replaced.tag_number
				} catch (repErr) {
					const detail = repErr.response?.data?.detail
					throw new Error(detail || repErr.message || "Tag replacement failed")
				}
			}
			// Process renewal dogs (Issue New Tags) — update the existing record in place
			const renewalMap = {}
			for (const row of receipt.filter(
				(r) =>
					(r.type === "dog" || r.type === "kennel_dog") &&
					renewalDogIds.has(r.dogId),
			)) {
				const rDog = dogs.find((x) => x[0] === row.dogId)
				const rCurAge = rDog && rDog[5] != null && rDog[5] !== "" ? Number(rDog[5]) : null
				const assignRequest = {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_ids: [row.dogId],
					tag_year: tagYear,
					// Renewal ages the dog one year (Issue New Tags).
					...(rCurAge != null && !Number.isNaN(rCurAge) ? { age: rCurAge + 1 } : {}),
				}
				const override = allOverrides.get(row.dogId) || unusedOverride
				if (override) {
					assignRequest.tag_number = parseInt(override, 10)
					if (!allOverrides.has(row.dogId)) unusedOverride = null
				}
				try {
					const { data: assigned } = await axios.post(
						DOG_TAG_ASSIGN_URL,
						assignRequest,
					)
					renewalMap[row.dogId] = { tagNumber: assigned.tags[0].tag_number }
				} catch (tagErr) {
					const detail = tagErr.response?.data?.detail
					throw new Error(detail || tagErr.message || "Tag assignment failed")
				}
			}
			if (
				Object.keys(tagMap).length > 0 ||
				Object.keys(renewalMap).length > 0
			) {
				setDogs((prev) =>
					prev.map((d) => {
						if (tagMap[d[0]]) {
							const updated = [d[0], tagYear, tagMap[d[0]], ...d.slice(3)]
							if (replacementDogIds.has(d[0])) updated[7] = "Active"
							return updated
						}
						if (renewalMap[d[0]]) {
							const { tagNumber } = renewalMap[d[0]]
							const bumpedAge = d[5] != null && d[5] !== "" && !Number.isNaN(Number(d[5])) ? Number(d[5]) + 1 : d[5]
							return [
								d[0],
								tagYear,
								tagNumber,
								d[3],
								d[4],
								bumpedAge,
								d[6],
								d[7],
								d[8],
								d[9],
								d[10],
								d[11],
								d[12],
							]
						}
						return d
					}),
				)
			}
			if (Object.keys(renewalMap).length > 0) setRenewalDogIds(new Set())

			const finalReceipt = receipt.map((row) => {
				// Replacement rows keep the marker so the deputy financial
				// reports can break lost tags out of the dog tag columns.
				const suffix = row.status === "Replacement" ? " (Replacement)" : ""
				if (
					(row.type === "dog" || row.type === "kennel_dog") &&
					tagMap[row.dogId]
				)
					return {
						...row,
						item: `Dog - ${row.dogName} #${tagMap[row.dogId]}${suffix}`,
					}
				if (
					(row.type === "dog" || row.type === "kennel_dog") &&
					renewalMap[row.dogId]
				)
					return {
						...row,
						item: `Dog - ${row.dogName} #${renewalMap[row.dogId].tagNumber}${suffix}`,
					}
				return row
			})
			setReceipt(finalReceipt)

			for (const row of finalReceipt) {
				await axios.post(TRANSACTION_ADD_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					taxpayer_id: formTaxpayerId,
					deputy_id: Token.login_id,
					item: row.item,
					quantity: row.qty,
					price: row.price,
					total: row.subtotal,
					payment_method: paymentMethod,
					check_number:
						paymentMethod === "Check" ? dogCheckNumber || null : null,
					receipt_number: parseInt(currentReceiptNumber),
				})
			}
			if (
				sgId !== null &&
				finalReceipt.some((r) => r.type === "sheep" || r.type === "goat")
			) {
				await axios.put(SHEEP_GOATS_DATE_PAID_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					id: sgId,
				})
			}
			const kennelRegRows = finalReceipt.filter((r) => r.type === "kennel_reg")
			for (const regRow of kennelRegRows) {
				await axios.post(KENNEL_REGISTER_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					taxpayer_id: formTaxpayerId,
					year: tagYear,
					registration_number: regRow.registrationNumber ?? 1,
					tag_count: regRow.tagCount || 5,
					kennel_name: formKennelName || null,
				})
			}
			if (kennelRegRows.length > 0) setExistingKennelRegistrations((prev) => prev + kennelRegRows.length)
			// Record which dogs had vicious fee paid this session
			const paidViciousDogIds = finalReceipt
				.filter((r) => r.type === "vicious")
				.map((r) => r.dogId)
			if (paidViciousDogIds.length > 0) {
				setViciousPaidDogIds((prev) => new Set([...prev, ...paidViciousDogIds]))
			}
			await printReceiptReport(currentReceiptNumber)
			const hasKennel = finalReceipt.some((r) => r.type === "kennel_reg" || r.type === "kennel_dog")
			if (hasKennel && formKennelName) {
				await printKennelCertificate(formKennelName, tagYear)
			}
			clearPageData()
		} catch (err) {
			setReceiptError(err.message)
		}
	}

	function handleDogRowClick(dog) {
		setDogId(dog[0])
		setDogTagNumber(dog[2] ?? "")
		setDogName(dog[3] ?? "")
		setDogSex(dog[4] ?? "M")
		setDogAge(dog[5] ?? "")
		setDogBreed(dog[6] ?? "")
		setDogFeeType(dog[7] || "Active")
		setDogHairColor(dog[8] ?? "")
		setHairColorCustom(false)
		setDogHairLength(dog[9] ?? "")
		setDogSize(dog[10] ?? "")
		setDogSpayNeuter(dog[11] ?? false)
		setDogVicious(dog[12] ?? false)
		setOriginalDogVicious(dog[12] ?? false)
		setDogAddMode(false)
		setDogError("")
	}

	// Blank dog name defaults to "<breed> <hair color>" (hair color title-cased)
	function effectiveDogName() {
		const typed = (dogName || "").trim()
		if (typed) return title_Case(typed)
		return `${dogBreed || ""} ${title_Case((dogHairColor || "").toLowerCase())}`.trim()
	}

	function buildDogBase() {
		return {
			login_id: Token.login_id,
			client_id: Token.client_id,
			dog_name: effectiveDogName() || null,
			sex: dogSex,
			age: dogAge !== "" ? Number(dogAge) : null,
			hair_color: dogHairColor || null,
			hair_length: dogHairLength || null,
			size: dogSize || null,
			breed: dogBreed || null,
			spay_neuter: dogSpayNeuter,
			vicious: dogVicious,
			status: dogFeeType,
		}
	}

	function handleDogApiError(err) {
		setDogStatus("")
		if (err.message === "Request failed with status code 401") {
			setDogError("Timeout")
		} else if (err.message === "Request failed with status code 404") {
			setDogError("No tags available for this deputy.")
		} else if (err.message === "Request failed with status code 500") {
			setDogError("500")
		} else {
			setDogError(err.message)
		}
	}

	async function handleTagOverrideBlur(val) {
		if (!val) {
			setTagOverrideError("")
			setTagOverrideInfo("")
			return
		}
		try {
			const { data } = await axios.post(DOG_TAGS_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				tag_year: tagYear,
				tag_number: parseInt(val, 10),
			})
			if (!data || data.length === 0) {
				setTagOverrideError(`Tag #${val} not found.`)
				setTagOverrideInfo("")
			} else if (data[0][5] === "Active") {
				setTagOverrideError(`Tag #${val} has already been issued.`)
				setTagOverrideInfo("")
			} else if (data[0][5] === "Unassigned") {
				setTagOverrideError("")
				setTagOverrideInfo(`Tag #${val} is unassigned`)
			} else if (data[0][5] === "Assigned") {
				const deputy = data[0][6] || "deputy of record"
				setTagOverrideError("")
				setTagOverrideInfo(
					`Tag #${val} is assigned to ${deputy} — get it from that deputy.`,
				)
			} else {
				setTagOverrideError(
					`Tag #${val} status is '${data[0][5]}' — cannot use this tag.`,
				)
				setTagOverrideInfo("")
			}
		} catch {
			setTagOverrideError("Could not validate tag number.")
			setTagOverrideInfo("")
		}
	}

	async function handleDogAdd() {
		setDogStatus("submitting")
		setDogError("")
		try {
			const effectiveStatus = dogFeeType
			let kennelCount = 0
			if (dogFeeType === "Kennel") {
				kennelCount = dogs.filter((d) => d[7] === "Kennel").length
			}
			const name = effectiveDogName()
			const { data: newDog } = await axios.post(DOG_LICENSE_ADD_URL, {
				...buildDogBase(),
				status: effectiveStatus,
				Taxpayer_id: formTaxpayerId,
				tag_year: String(tagYear),
			})
			// newDog is [id, tag_year, tag_number, dog_name, sex, age, breed, status]
			const dogRow = [...newDog]
			setDogs((prev) => [...prev, dogRow])
			if (tagOverride) {
				setNewDogTagOverrides(
					(prev) => new Map([...prev, [newDog[0], tagOverride]]),
				)
			}
			if (receipt.length === 0) await fetchReceiptNumber()
			const tagNum = dogRow[2]
			const label = tagNum ? `Dog - ${name} #${tagNum}` : `Dog - ${name}`
			let price
			if (dogFeeType === "Service Dog") {
				price = 0
			} else if (dogFeeType === "Replacement") {
				price = getFee("lost_tag")
			} else if (dogFeeType === "Kennel") {
				price = kennelCount + 1 <= 5 ? 0 : getFee("dog")
			} else {
				price = getFee("dog")
			}
			const rowType =
				dogFeeType === "Kennel" && effectiveStatus === "Kennel"
					? "kennel_dog"
					: "dog"
			const newRows = [
				{
					type: rowType,
					item: label,
					status: effectiveStatus,
					breed: dogBreed,
					qty: 1,
					price,
					subtotal: price,
					dogId: newDog[0],
					dogName: name,
				},
			]
			if (dogVicious) {
				const vPrice = getFee("vicious")
				newRows.push({
					type: "vicious",
					item: `Vicious - ${name}`,
					qty: 1,
					price: vPrice,
					subtotal: vPrice,
					dogId: newDog[0],
					dogName: name,
				})
			}
			setReceipt((prev) => [...prev, ...newRows])
			clearDogForm()
			setDogAddMode(true)
			setDogStatus("")
		} catch (err) {
			handleDogApiError(err)
		}
	}

	async function handleAddKennelRegistration() {
		if (kennelAddInProgress.current) return
		if (!formTaxpayerId) return
		if (!formKennelName.trim()) { setKennelNameMissing(true); return }
		// A second registration in a year is usually a repeat click, not intent
		// (Brooke allows one per taxpayer) -- require a confirming second click.
		const regsThisYear = existingKennelRegistrations +
			(printed ? 0 : receipt.filter((r) => r.type === "kennel_reg").length)
		if (regsThisYear > 0 && kennelAddStatus !== "confirm") {
			setKennelAddStatus("confirm")
			return
		}
		kennelAddInProgress.current = true
		setKennelAddStatus("submitting")

		// If the previous receipt was already printed, start a fresh receipt.
		// Use local variables so stale state doesn't affect regNum or the receipt number.
		const startingFresh = printed
		const pendingKennelRegs = startingFresh
			? 0
			: receipt.filter((r) => r.type === "kennel_reg").length

		try {
			const regNum = existingKennelRegistrations + pendingKennelRegs + 1
			const newDogs = []
			const newReceipt = []
			const convertedDogIds = []
			const convertedNameMap = {}  // dogId → new name for dogs that were renamed

			// Get a receipt number — bypass the guard when starting fresh
			if (startingFresh) {
				const { data: rn } = await axios.post(RECEIPT_NEXT_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
				})
				setReceiptNumber(String(rn.receipt_number))
			} else if (receipt.length === 0) {
				await fetchReceiptNumber()
			}

			const kennelFee = getFee("kennel")
			newReceipt.push({
				type: "kennel_reg",
				item: `Kennel Registration R${regNum}`,
				qty: 1,
				price: kennelFee,
				subtotal: kennelFee,
				registrationNumber: regNum,
				tagCount: 5,
			})

			// Eligible: non-service dogs that are either not kennel, or are prior-year kennel dogs.
			// Current-year kennel dogs are already in this year's registration — leave them untouched.
			const kennelPlaceholder = (name) => /^R\d+-D\d+$/.test(name || '')
			const convertible = dogs.filter(
				(d) =>
					d[7] !== "Service Dog" &&
					(d[7] !== "Kennel" || Number(d[1]) < tagYear)
			)
			let slotsFilled = 0
			for (const dog of convertible) {
				if (slotsFilled >= 5) break
				slotsFilled++
				const isPriorYear = Number(dog[1]) < tagYear
				// Nameless dogs, placeholder names, and auto "breed + color" fallback names
				// all get a fresh R{reg}-D{slot} name. Only real (typed) names are kept.
				const dogFallback = `${dog[6] || ""} ${title_Case((dog[8] || "").toLowerCase())}`.trim()
				const needsRename = !dog[3] || kennelPlaceholder(dog[3]) || dog[3] === dogFallback
				const dogName = needsRename ? `R${regNum}-D${slotsFilled}` : dog[3]
				await axios.post(DOG_LICENSE_UPDATE_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_id: dog[0],
					tag_year: isPriorYear ? tagYear : undefined,
					dog_name: dogName,
					sex: dog[4] || null,
					age: dog[5] != null ? Number(dog[5]) : null,
					hair_color: dog[8] || null,
					hair_length: dog[9] || null,
					size: dog[10] || null,
					breed: dog[6] || null,
					spay_neuter: dog[11] ?? false,
					vicious: dog[12] ?? false,
					status: "Kennel",
				})
				convertedDogIds.push(dog[0])
				if (needsRename) convertedNameMap[dog[0]] = dogName
				newReceipt.push({
					type: "kennel_dog",
					item: `Dog - ${dogName}`,
					status: 'Kennel',
					breed: dog[6] || '',
					qty: 1,
					price: 0,
					subtotal: 0,
					dogId: dog[0],
					dogName,
					registrationNumber: regNum,
				})
			}

			// Create placeholder dogs for remaining slots
			for (let i = slotsFilled + 1; i <= 5; i++) {
				const dogName = `R${regNum}-D${i}`
				const { data: newDog } = await axios.post(DOG_LICENSE_ADD_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_name: dogName,
					sex: null,
					age: null,
					hair_color: null,
					hair_length: null,
					size: null,
					breed: null,
					spay_neuter: false,
					vicious: false,
					status: "Kennel",
					Taxpayer_id: formTaxpayerId,
					tag_year: String(tagYear),
				})
				newDogs.push(newDog)
				newReceipt.push({
					type: "kennel_dog",
					item: `Dog - ${dogName}`,
					status: 'Kennel',
					qty: 1,
					price: 0,
					subtotal: 0,
					dogId: newDog[0],
					dogName,
					registrationNumber: regNum,
				})
			}

			// Update local dogs state: converted dogs get current tag_year, Kennel status, and new name if renamed
			setDogs((prev) => [
				...prev.map((d) => convertedDogIds.includes(d[0])
					? [d[0], Number(d[1]) < tagYear ? tagYear : d[1], d[2], convertedNameMap[d[0]] ?? d[3], d[4], d[5], d[6], "Kennel", d[8], d[9], d[10], d[11], d[12]]
					: d),
				...newDogs,
			])
			// Fresh start: replace the entire receipt. Mid-session: remove old "dog" rows and append.
			if (startingFresh) {
				setReceipt(newReceipt)
				setPrinted(false)
			} else {
				setReceipt((prev) => [
					...prev.filter((r) => !(convertedDogIds.includes(r.dogId) && r.type === "dog")),
					...newReceipt,
				])
			}
			// Prior-year converted dogs must be flagged as renewal-handled so Issue New Tags skips them
			const priorYearConvertedIds = convertible.slice(0, slotsFilled)
				.filter((d) => Number(d[1]) < tagYear)
				.map((d) => d[0])
			if (priorYearConvertedIds.length > 0) {
				setRenewalDogIds((prev) => new Set([...prev, ...priorYearConvertedIds]))
			}
		} catch (err) {
			kennelAddInProgress.current = false
			setKennelAddStatus("error:" + (err.response?.data?.detail || err.message))
			return
		}
		kennelAddInProgress.current = false
		setKennelAddStatus("")
	}

	async function handleDogSave() {
		setDogStatus("submitting")
		setDogError("")
		try {
			const name = effectiveDogName()
			const { data } = await axios.post(DOG_LICENSE_UPDATE_URL, {
				...buildDogBase(),
				dog_id: dogId,
			})
			setDogs((prev) => prev.map((d) => (d[0] === dogId ? data : d)))
			if (dogFeeType === "Replacement") {
				const price = getFee("lost_tag")
				if (receipt.length === 0) await fetchReceiptNumber()
				setReceipt((prev) => {
					const idx = prev.findIndex((r) => r.dogId === dogId)
					const row = {
						type: "dog",
						item: `Dog - ${name} (Replacement)`,
						status: 'Replacement',
						qty: 1,
						price,
						subtotal: price,
						dogId,
						dogName: name,
					}
					if (idx >= 0) {
						const u = [...prev]
						u[idx] = row
						return u
					}
					return [...prev, row]
				})
				const currentDog = dogs.find((d) => d[0] === dogId)
				if (currentDog && currentDog[2]) {
					setReplacementDogIds((prev) => new Set([...prev, dogId]))
				}
			} else {
				let updatedType, updatedPrice
				if (dogFeeType === "Service Dog") {
					updatedType = "dog"
					updatedPrice = 0
				} else if (dogFeeType === "Kennel") {
					updatedType = "kennel_dog"
					const kennelInReceiptExcludingThis = receipt.filter(
						(r) => r.type === "kennel_dog" && r.dogId !== dogId,
					).length
					const totalFreeSlots = (existingKennelRegistrations + receipt.filter((r) => r.type === "kennel_reg").length) * 5
					updatedPrice = kennelInReceiptExcludingThis < totalFreeSlots ? 0 : getFee("dog")
				} else {
					updatedType = "dog"
					updatedPrice = getFee("dog")
				}
				const existingTag = dogs.find((d) => d[0] === dogId)?.[2]
				const updatedItem = existingTag ? `Dog - ${name} #${existingTag}` : `Dog - ${name}`
				setReceipt((prev) =>
					prev.map((r) =>
						r.dogId === dogId && (r.type === "dog" || r.type === "kennel_dog")
							? { ...r, type: updatedType, status: dogFeeType, price: updatedPrice, subtotal: updatedPrice, dogName: name, breed: dogBreed, item: updatedItem }
							: r,
					),
				)
			}
			// Add vicious fee only if newly marked vicious AND fee not already paid this session
			if (dogVicious && !originalDogVicious && !viciousPaidDogIds.has(dogId)) {
				const vPrice = getFee("vicious")
				setReceipt((prev) => {
					const idx = prev.findIndex((r) => r.dogId === dogId && r.type === "vicious")
					const row = { type: "vicious", item: `Vicious - ${name}`, qty: 1, price: vPrice, subtotal: vPrice, dogId, dogName: name }
					if (idx >= 0) { const u = [...prev]; u[idx] = row; return u }
					return [...prev, row]
				})
			} else if (!dogVicious && !viciousPaidDogIds.has(dogId)) {
				// Remove fee only if it hasn't been paid (still pending in receipt)
				setReceipt((prev) => prev.filter((r) => !(r.dogId === dogId && r.type === "vicious")))
			}
			if (tagOverride && dogId !== null) {
				setNewDogTagOverrides((prev) => new Map([...prev, [dogId, tagOverride]]))
			}
			clearDogForm()
			setDogAddMode(true)
			setDogStatus("")
		} catch (err) {
			handleDogApiError(err)
		}
	}

	async function handleDogDelete(id) {
		try {
			await axios.post(DOG_LICENSE_DELETE_URL, {
				login_id: Token.login_id,
				client_id: Token.client_id,
				dog_id: id,
			})
			setDogs((prev) => prev.filter((d) => d[0] !== id))
			// Only remove from receipt if this dog was added in the current session
			const deletedKennelRow = receipt.find((r) => r.dogId === id && r.type === "kennel_dog")
			const deletedRegNum = deletedKennelRow?.registrationNumber
			if (newDogTagOverrides.has(id) || receipt.some((r) => r.dogId === id)) {
				setReceipt((prev) => {
					const filtered = prev.filter((r) => r.dogId !== id)
					// Remove the kennel_reg row for this registration if no dogs from it remain
					if (deletedRegNum != null && !filtered.some((r) => r.type === "kennel_dog" && r.registrationNumber === deletedRegNum)) {
						return filtered.filter((r) => !(r.type === "kennel_reg" && r.registrationNumber === deletedRegNum))
					}
					return filtered
				})
				setNewDogTagOverrides((prev) => {
					const m = new Map(prev)
					m.delete(id)
					return m
				})
			}
			clearDogForm()
			setDogAddMode(true)
		} catch (err) {
			setDogError(err.response?.data?.detail || err.message)
		}
	}

	function handleIssueNewTagsClick() {
		const hasKennelDogs = dogs.some(
			(d) => Number(d[1]) < tagYear && d[7] === "Kennel" && !renewalDogIds.has(d[0])
		)
		if (hasKennelDogs) {
			setShowKennelWarning(true)
		} else {
			handleIssueNewTags()
		}
	}

	async function handleIssueNewTags() {
		const pastYearDogs = dogs.filter(
			(d) => Number(d[1]) < tagYear && !renewalDogIds.has(d[0]),
		)
		if (pastYearDogs.length === 0) return
		setRenewalDogIds(
			new Set([...renewalDogIds, ...pastYearDogs.map((d) => d[0])]),
		)
		if (receipt.length === 0) await fetchReceiptNumber()

		const newRows = []
		const kennelConvertedIds = []

		for (const dog of pastYearDogs) {
			const originalStatus = dog[7]
			// Keep a real name; otherwise (blank, or a cleared kennel R#-D# placeholder)
			// fall back to "<breed> <hair color>" as done when adding/updating a dog.
			const isPlaceholder = /^R\d+-D\d+$/.test(dog[3] || "")
			const realName = (dog[3] || "").trim()
			const dogName = realName && !isPlaceholder
				? title_Case(realName)
				: `${dog[6] || ""} ${title_Case((dog[8] || "").toLowerCase())}`.trim()
			let effectiveStatus, price

			if (originalStatus === "Service Dog") {
				effectiveStatus = "Service Dog"
				price = 0
			} else if (originalStatus === "Kennel") {
				// Convert to Active: replace the kennel placeholder name, charge full price, update DB now
				effectiveStatus = "Active"
				price = getFee("dog")
				await axios.post(DOG_LICENSE_UPDATE_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_id: dog[0],
					tag_year: tagYear,
					dog_name: dogName || null,
					sex: dog[4] || null,
					age: dog[5] != null ? Number(dog[5]) : null,
					hair_color: dog[8] || null,
					hair_length: dog[9] || null,
					size: dog[10] || null,
					breed: dog[6] || null,
					spay_neuter: dog[11] ?? false,
					vicious: dog[12] ?? false,
					status: "Active",
				})
				kennelConvertedIds.push(dog[0])
			} else {
				effectiveStatus = "Active"
				price = getFee("dog")
			}

			// Persist a newly-derived fallback name (blank/placeholder → "breed + hair
			// color") so the dog is actually renamed going forward, matching Add/Update.
			// tag_year:null keeps the current year and status:dog[7] preserves the tag,
			// so the renewal itself is untouched. The Kennel branch already wrote its name.
			if (originalStatus !== "Kennel" && dogName !== (dog[3] || "")) {
				await axios.post(DOG_LICENSE_UPDATE_URL, {
					login_id: Token.login_id,
					client_id: Token.client_id,
					dog_id: dog[0],
					tag_year: null,
					dog_name: dogName,
					sex: dog[4] || null,
					age: dog[5] != null ? Number(dog[5]) : null,
					hair_color: dog[8] || null,
					hair_length: dog[9] || null,
					size: dog[10] || null,
					breed: dog[6] || null,
					spay_neuter: dog[11] ?? false,
					vicious: dog[12] ?? false,
					status: dog[7],
				})
			}

			newRows.push({
				type: "dog",
				item: `Dog - ${dogName}`,
				status: effectiveStatus,
				breed: dog[6],
				qty: 1,
				price,
				subtotal: price,
				dogId: dog[0],
				dogName,
			})
			if (dog[12]) {
				const vPrice = getFee("vicious")
				newRows.push({
					type: "vicious",
					item: `Vicious - ${dogName}`,
					qty: 1,
					price: vPrice,
					subtotal: vPrice,
					dogId: dog[0],
					dogName,
				})
			}
		}

		// Update local state: kennel-converted dogs get Active status and no name
		if (kennelConvertedIds.length > 0) {
			setDogs((prev) => prev.map((d) =>
				kennelConvertedIds.includes(d[0])
					? [d[0], d[1], d[2], "", d[4], d[5], d[6], "Active", d[8], d[9], d[10], d[11], d[12]]
					: d
			))
		}

		setReceipt((prev) => [...prev, ...newRows])
	}

	return (
		<main className="Main">
			<div className="dtpf-scope">
				{!IsDeputy && (
					<div style={{ backgroundColor: "transparent", color: "gold", textAlign: "center", fontWeight: "bold", fontSize: "2.15rem", padding: "0.6rem", marginBottom: "0.75rem" }}>
						Warning: Deputy is not authorized for license operations.
					</div>
				)}
				<div className="dtpf-main-grid">
					<div className="dtpf-left-2col">
						<fieldset className="dtpf-fs-search">
							<legend>Taxpayer Search</legend>
							<table style={{ border: "none" }}>
								<tbody>
									<tr style={{ backgroundColor: "transparent" }}>
										<td
											style={{
												textAlign: "right",
												border: "none",
												whiteSpace: "nowrap",
											}}
										>
											<button
												className="taxpayer-saveBtn"
												type="button"
												style={{ marginRight: "0.75rem" }}
												onClick={handleClear}
											>
												Clear Page
											</button>
											<label htmlFor="searchby">Search By:</label>
										</td>
										<td style={{ textAlign: "left", border: "none" }}>
											<input
												name="searchby"
												id="searchby"
												type="text"
												className="f1-input"
												placeholder="Tag # | Name (any order) | Email | Phone"
												style={{ width: "24rem" }}
												autoFocus
												value={formSearchBy}
												onChange={(e) => handleSearchbyChange(e)}
												onKeyDown={handleSearchByKeyDown}
											/>
										</td>
									</tr>
								</tbody>
							</table>
							<ErrorPopup
								message={searchError}
								onClose={() => setSearchError("")}
							/>
							{searchResults.length > 0 && (
								<div
									className="table_container scroll-table-5"
									style={{ marginTop: "0.75rem" }}
								>
									<table>
										<thead>
											<tr>
												{searchResults.some((r) => r.tag_year) && (
													<>
														<th>Year</th>
														<th>Tag#</th>
													</>
												)}
												<th>Last Name</th>
												<th>First Name</th>
												<th>Address</th>
												<th>City, State</th>
												<th>Dogs</th>
											</tr>
										</thead>
										<tbody>
											{searchResults.map((tp) => (
												<tr
													// One taxpayer can appear twice: the same owner can draw the
													// same number in consecutive years, so tp.id is not unique.
													key={`${tp.id}-${tp.tag_year ?? ""}-${tp.dog_id ?? ""}`}
													onClick={() => handleSearchResultClick(tp.id, tp.dog_id)}
													style={{ cursor: "pointer" }}
												>
													{searchResults.some((r) => r.tag_year) && (
														<>
															<td style={{ textAlign: "center" }}>{tp.tag_year}</td>
															<td style={{ textAlign: "center" }}>{tp.tag_number}</td>
														</>
													)}
													<td>{tp.last_name}</td>
													<td>{tp.first_name}</td>
													<td>
														{[tp.number_addr1, tp.street_addr1]
															.filter(Boolean)
															.join(" ")}
													</td>
													<td>
														{[tp.city_name, tp.state_code]
															.filter(Boolean)
															.join(", ")}
													</td>
													<td style={{ textAlign: "center" }}>{tp.dog_count}</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							)}
						</fieldset>
						<fieldset className="dtpf-fs-taxpayer">
							<legend>Taxpayer Information</legend>
							<form
								name="InputForm"
								onSubmit={handleTaxpayerSave}
								style={{ marginTop: "-2rem" }}
							>
								<div style={{ color: "gold", marginTop: "1.5rem", marginBottom: "0.25rem" }}>
									Yellow is a required field
								</div>
								<table id="tbl_box" style={{ border: "none" }}>
									<tbody>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="district">District:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<select
													name="district"
													id="district"
													value={formDistrict}
													onChange={(e) => handleDistrictChange(e)}
												>
													<option value=""></option>
													{DistrictList.map((d) => (
														<option key={d.name} value={d.name}>
															{d.name}
														</option>
													))}
												</select>
											</td>
											<td style={{ textAlign: "right", border: "none", width: "1%", whiteSpace: "nowrap" }}>
												<label htmlFor="kennelName">Kennel Name:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="text"
													id="kennelName"
													value={formKennelName}
													style={kennelNameMissing ? { border: "2px solid red" } : {}}
													onChange={(e) => {
														setFormKennelName(title_Case(e.target.value))
														if (e.target.value.trim()) setKennelNameMissing(false)
													}}
													onBlur={async (e) => {
														if (!formTaxpayerId) return
														const trimmed = e.target.value.trim()
														try {
															await axios.put(TAXPAYER_EDIT_URL, {
																login_id: Token.login_id,
																client_id: Token.client_id,
																id: formTaxpayerId,
																lastname: formLastname,
																firstname: formFirstname,
																email: formEmail,
																phone: formPhone,
																number_addr1: formNumAddr1,
																street_addr1: formStAddr1,
																addr2: formAddr2,
																cityname: formCity,
																statecode: formStateCode,
																zip: formZip,
																district: formDistrict,
																note: formNote,
																kennel_name: trimmed || null,
															})
															setStatus("success")
															setTimeout(() => setStatus(""), 2000)
														} catch {
															// silent — full save will surface errors
														}
													}}
												/>
											</td>
										</tr>
										<tr>
											<td style={{ textAlign: "right", border: "none", width: "1%", whiteSpace: "nowrap" }}>
												<label>Kennel Reg:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }} colSpan={3}>
												<button
													type="button"
													className="taxpayer-saveBtn"
													disabled={!formTaxpayerId || kennelAddStatus === "submitting" || !IsDeputy}
													onClick={handleAddKennelRegistration}
												>
													{kennelAddStatus === "submitting" ? "Adding…" : `Add Kennel Registration (R${existingKennelRegistrations + receipt.filter((r) => r.type === "kennel_reg").length + 1})`}
												</button>
												{existingKennelRegistrations + receipt.filter((r) => r.type === "kennel_reg").length > 0 && (
													<span style={{ marginLeft: "1rem", fontSize: "0.9rem", color: "white" }}>
														{existingKennelRegistrations + receipt.filter((r) => r.type === "kennel_reg").length} registration(s) — {(existingKennelRegistrations + receipt.filter((r) => r.type === "kennel_reg").length) * 5} free tags
													</span>
												)}
												{kennelAddStatus.startsWith("error:") && (
													<span style={{ marginLeft: "1rem", color: "red", fontSize: "0.9rem" }}>{kennelAddStatus.slice(6)}</span>
												)}
												{kennelAddStatus === "confirm" && (
													<span style={{ marginLeft: "1rem", color: "red", fontSize: "0.9rem" }}>
														This taxpayer already has a kennel registration this year. Click again to add another.
													</span>
												)}
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="userFirstname" style={!(formFirstname || "").trim() ? { color: "gold" } : undefined}>First Name:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="userFirstname"
													id="userFirstname"
													type="text"
													required
													value={formFirstname}
													style={FN_bgc}
													onChange={(e) => handleFirstnameChange(e)}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "100px",
												}}
											>
												<label htmlFor="userLastname" style={!(formLastname || "").trim() ? { color: "gold" } : undefined}>Last Name:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="userLastname"
													id="userLastname"
													type="text"
													required
													disabled={SB_Valid}
													onChange={(e) => handleLastnameChange(e)}
													value={formLastname}
													style={LN_bgc}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="customerEmail">Email:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="customerEmail"
													id="customerEmail"
													type="text"
													value={formEmail}
													style={EM_bgc}
													onChange={(e) => handleEmailChange(e)}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="userPhone">Phone:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="userPhone"
													id="userPhone"
													type="text"
													placeholder="Mobile Phone Only"
													value={formPhone}
													style={PN_bgc}
													onChange={(e) => handlePhoneChange(e)}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="numAddr1">Number:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="numAddr1"
													id="numAdd1"
													type="text"
													placeholder="Street Number"
													value={formNumAddr1}
													style={NA_bgc}
													onChange={(e) => handleNumAddr1Change(e)}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="StreetAddr1" style={!(formStAddr1 || "").trim() ? { color: "gold" } : undefined}>Street:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="StreetAddr1"
													id="StreetAdd1"
													type="text"
													placeholder="Street Name"
													required
													value={formStAddr1}
													style={SA_bgc}
													onChange={(e) => handleStAddr1Change(e)}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="taxpayerAddr2">Addr2:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="taxpayerAddr2"
													id="taxpayerAddr2"
													type="text"
													placeholder="Apt, Unit, etc."
													value={formAddr2}
													style={A2_bgc}
													onChange={(e) => handleAddr2Change(e)}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="city" style={!(formCity || "").trim() ? { color: "gold" } : undefined}>City Name:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="city"
													id="city"
													type="text"
													required
													value={formCity}
													style={CN_bgc}
													onChange={(e) => handleCityChange(e)}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="taxpayerSC" style={!(formStateCode || "").trim() ? { color: "gold" } : undefined}>State Code:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="taxpayerSC"
													id="taxpayerSC"
													type="text"
													placeholder="State Code (e.g. WV)"
													required
													value={formStateCode}
													style={SC_bgc}
													onChange={(e) => handleStateCodeChange(e)}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="taxpayerZip">Zip:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													ref={firstnameRef}
													name="taxpayerZip"
													id="taxpayerZip"
													type="text"
													value={formZip}
													style={ZP_bgc}
													onChange={(e) => handleZipChange(e)}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="taxpayerNote">Note:</label>
											</td>
											<td
												style={{ textAlign: "left", border: "none" }}
												colSpan={4}
											>
												<textarea
													name="taxpayerNote"
													id="taxpayerNote"
													value={formNote}
													style={{
														height: formNote ? "5rem" : "1.8rem",
														resize: "none",
														width: "100%",
														overflow: "hidden",
														transition: "height 0.2s ease",
													}}
													onChange={(e) => handleNoteChange(e)}
												/>
											</td>
										</tr>
									</tbody>
								</table>
								<div style={{ textAlign: "center", marginTop: "0.5rem" }}>
									<ErrorPopup message={error} onClose={() => setError("")} />
									{status === "success" && (
										<StatusPopup message={formTaxpayerId ? "Taxpayer Updated!" : "Taxpayer Added!"} />
									)}
									<div
										style={{
											display: "flex",
											gap: "0.75rem",
											justifyContent: "center",
											marginTop: "0.5rem",
										}}
									>
										<button
											className="taxpayer-saveBtn"
											type="submit"
											disabled={
												!LN_Valid ||
												!FN_Valid ||
												!NA_Valid ||
												!SA_Valid ||
												!CN_Valid ||
												!SC_Valid ||
												Token.client_id === 0 ||
												status === "submitting"
											}
										>
											{formTaxpayerId ? "Save" : "Add Taxpayer"}
										</button>
										{formTaxpayerId && !taxpayerHasTransactions && (
											<button
												className="taxpayer-saveBtn"
												type="button"
												style={{ backgroundColor: "#c0392b", color: "white" }}
												onClick={() => setShowDeleteConfirm(true)}
											>
												Delete
											</button>
										)}
									</div>
								</div>
							</form>
						</fieldset>

						{dupMatches && (
							<div
								style={{
									position: "fixed",
									top: 0,
									left: 0,
									width: "100vw",
									height: "100vh",
									backgroundColor: "rgba(0,0,0,0.6)",
									zIndex: 1000,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div
									style={{
										background: "#1a1a1a",
										border: "2px solid #e67e22",
										borderRadius: "6px",
										padding: "1.5rem 2rem",
										maxWidth: "480px",
										width: "90%",
										color: "white",
									}}
								>
									<p style={{ marginBottom: "0.75rem", fontWeight: "bold", color: "#e67e22" }}>
										Possible Duplicate
									</p>
									<p style={{ marginBottom: "1rem", lineHeight: "1.5" }}>
										A taxpayer with this name is already on file in this town. Check the
										address below — if it is the same person at a new address, use the
										existing record and update it rather than creating a second one.
									</p>
									<div style={{ maxHeight: "40vh", overflowY: "auto", marginBottom: "1rem" }}>
										{dupMatches.map((m) => (
											<div
												key={m.id}
												style={{
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
													gap: "1rem",
													padding: "0.5rem 0",
													borderBottom: "1px solid #333",
												}}
											>
												<span style={{ lineHeight: "1.4" }}>
													<strong>{m.first_name} {m.last_name}</strong>
													<br />
													{m.number_addr1} {m.street_addr1}, {m.city_name} {m.state_code} {m.zip}
													<br />
													<span style={{ fontSize: "0.85rem", opacity: 0.8 }}>
														{m.dog_count || m.transaction_count
															? [
																	m.dog_count ? `${m.dog_count} dog(s)` : null,
																	m.transaction_count ? `${m.transaction_count} payment(s)` : null,
															  ]
																	.filter(Boolean)
																	.join(", ")
															: "nothing on file yet"}
													</span>
												</span>
												<button
													className="taxpayer-saveBtn"
													type="button"
													onClick={() => {
														setDupMatches(null)
														handleSearchResultClick(m.id)
													}}
												>
													Use this record
												</button>
											</div>
										))}
									</div>
									<div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
										<button
											className="taxpayer-saveBtn"
											type="button"
											style={{ backgroundColor: "#e67e22", color: "white" }}
											onClick={() => submitAddTaxpayer(true)}
										>
											Add anyway
										</button>
										<button
											className="taxpayer-saveBtn"
											type="button"
											onClick={() => setDupMatches(null)}
										>
											Cancel
										</button>
									</div>
								</div>
							</div>
						)}

						{showDeleteConfirm && (
							<div
								style={{
									position: "fixed",
									top: 0,
									left: 0,
									width: "100vw",
									height: "100vh",
									backgroundColor: "rgba(0,0,0,0.6)",
									zIndex: 1000,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div
									style={{
										background: "#1a1a1a",
										border: "2px solid #c0392b",
										borderRadius: "6px",
										padding: "1.5rem 2rem",
										maxWidth: "420px",
										width: "90%",
										color: "white",
									}}
								>
									<p
										style={{
											marginBottom: "1rem",
											fontWeight: "bold",
											color: "#e74c3c",
										}}
									>
										Delete Taxpayer
									</p>
									<p style={{ marginBottom: "1.25rem", lineHeight: "1.6" }}>
										This will permanently delete{" "}
										<strong>
											{formFirstname} {formLastname}
										</strong>{" "}
										and all associated dog records. This cannot be undone.
									</p>
									<div
										style={{
											display: "flex",
											gap: "1rem",
											justifyContent: "center",
										}}
									>
										<button
											className="taxpayer-saveBtn"
											type="button"
											style={{ backgroundColor: "#c0392b", color: "white" }}
											onClick={handleTaxpayerDelete}
										>
											Confirm Delete
										</button>
										<button
											className="taxpayer-saveBtn"
											type="button"
											onClick={() => setShowDeleteConfirm(false)}
										>
											Cancel
										</button>
									</div>
								</div>
							</div>
						)}
						<fieldset className="dtpf-fs-sheep" disabled={!formTaxpayerId}>
							<legend>Sheep &amp; Goats</legend>
							<table style={{ border: "none" }}>
								<tbody>
									<tr style={{ backgroundColor: "transparent" }}>
										<td
											style={{
												textAlign: "right",
												border: "none",
												width: "1%",
												whiteSpace: "nowrap",
											}}
										>
											<label htmlFor="sheep">Sheep #:</label>
										</td>
										<td style={{ textAlign: "left", border: "none" }}>
											<input
												type="text"
												name="sheep"
												id="sheep"
												className="f1-input"
												value={sgSheep}
												style={{ width: "6ch", textAlign: "center" }}
												readOnly={printed || !!sgDatePaid}
												onFocus={(e) => {
													if (printed || !!sgDatePaid) {
														e.target.blur()
														setShowSgLocked(true)
													} else e.target.select()
												}}
												onChange={(e) => {
													if (/^\d*$/.test(e.target.value))
														setSgSheep(e.target.value)
												}}
												onKeyDown={(e) => {
													if (e.key === "F1") {
														e.preventDefault()
														setShowSgHelp(true)
													}
												}}
											/>
										</td>
										<td
											style={{
												textAlign: "right",
												border: "none",
												width: "100px",
											}}
										>
											<label htmlFor="goats">Goats #:</label>
										</td>
										<td style={{ textAlign: "left", border: "none" }}>
											<input
												type="text"
												name="goats"
												id="goats"
												className="f1-input"
												value={sgGoats}
												style={{ width: "6ch", textAlign: "center" }}
												readOnly={printed || !!sgDatePaid}
												onFocus={(e) => {
													if (printed || !!sgDatePaid) {
														e.target.blur()
														setShowSgLocked(true)
													} else e.target.select()
												}}
												onChange={(e) => {
													if (/^\d*$/.test(e.target.value))
														setSgGoats(e.target.value)
												}}
												onKeyDown={(e) => {
													if (e.key === "F1") {
														e.preventDefault()
														setShowSgHelp(true)
													}
												}}
											/>
										</td>
										<td
											style={{
												textAlign: "center",
												border: "none",
												paddingLeft: "1rem",
											}}
										>
											<button
												className="taxpayer-saveBtn"
												type="button"
												disabled={
													!formTaxpayerId ||
													sgStatus === "submitting" ||
													!!sgDatePaid ||
													printed ||
													!IsDeputy
												}
												onClick={handleSgSave}
											>
												Save
											</button>
											{sgStatus === "success" && <StatusPopup message="Saved!" />}
											<ErrorPopup
												message={sgError}
												onClose={() => setSgError("")}
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</fieldset>
					</div>
					<div className="dtpf-right-2col">
						<div className="dtpf-col2">
							<fieldset className="dtpf-fs-dogs">
								<legend>Dogs on File</legend>
								<div className="table_container scroll-table-5">
									<table>
										<thead>
											<tr>
												<th>Year</th>
												<th>Tag #</th>
												<th>Dog Name</th>
												<th>Sex</th>
												<th>Age</th>
												<th>Breed</th>
												<th>Status</th>
												<th>Delete</th>
											</tr>
										</thead>
										{dogs.length > 0 ? (
											<tbody>
												{dogs.map((dog) => (
													<tr
														key={dog[0]}
														onClick={() => handleDogRowClick(dog)}
														style={{ cursor: "pointer" }}
													>
														<td
															style={
																!renewalDogIds.has(dog[0]) && Number(dog[1]) < tagYear
																	? { textAlign: "center", fontWeight: "bold", color: "red" }
																	: { textAlign: "center" }
															}
														>
															{dog[1]}
														</td>
														<td
															style={
																!renewalDogIds.has(dog[0]) &&
																dog[2] &&
																Number(dog[1]) < tagYear
																	? { textAlign: "center", fontWeight: "bold", color: "red" }
																	: { textAlign: "center" }
															}
														>
															{renewalDogIds.has(dog[0]) ? "" : dog[2]}
														</td>
														<td
															style={
																!renewalDogIds.has(dog[0]) &&
																Number(dog[1]) < tagYear
																	? { fontWeight: "bold", color: "red" }
																	: undefined
															}
														>
															{dog[3]}
														</td>
														<td style={{ textAlign: "center" }}>{dog[4]}</td>
														<td style={{ textAlign: "center" }}>{dog[5]}</td>
														<td>{dog[6]}</td>
														<td>{dog[7]}</td>
														<td>
															<button
																className="tblBtn"
																type="button"
																disabled={printed}
																onClick={(e) => {
																	e.stopPropagation()
																	handleDogDelete(dog[0])
																}}
															>
																Delete
															</button>
														</td>
													</tr>
												))}
											</tbody>
										) : (
											<tbody>
												<tr>
													<td colSpan={8}></td>
												</tr>
											</tbody>
										)}
									</table>
								</div>
								{dogs.some(
									(d) => Number(d[1]) < tagYear && !renewalDogIds.has(d[0]),
								) && (
									<div style={{ textAlign: "center", marginTop: "0.5rem" }}>
										<button
											className="taxpayer-saveBtn"
											type="button"
											style={{ minWidth: "9rem" }}
											disabled={printed || !IsDeputy}
											onClick={handleIssueNewTagsClick}
										>
											Issue New Tags
										</button>
									</div>
								)}
								{showKennelWarning && (
									<div style={{
										position: "fixed", top: 0, left: 0,
										width: "100vw", height: "100vh",
										backgroundColor: "rgba(0,0,0,0.6)",
										zIndex: 1000, display: "flex",
										alignItems: "center", justifyContent: "center",
									}}>
										<div style={{
											backgroundColor: "#2c2c2c", color: "white",
											borderRadius: "8px", padding: "1.5rem 2rem",
											maxWidth: "480px", width: "90%",
										}}>
											<p style={{ fontWeight: "bold", color: "#e74c3c", marginBottom: "0.75rem" }}>
												⚠ Kennel Dogs Detected
											</p>
											<p style={{ marginBottom: "0.75rem" }}>
												This taxpayer has prior-year dogs with <strong>Kennel</strong> status.
												Continuing will renew them as regular <strong>Active</strong> dogs at the
												full dog fee — they will no longer be part of a kennel registration.
											</p>
											<p style={{ marginBottom: "1.25rem" }}>
												If the taxpayer is renewing their kennel, consider using the{" "}
												<strong>Add Kennel Registration</strong> button instead, which will
												carry the kennel dogs forward into a new registration at no per-dog charge.
											</p>
											<div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
												<button
													className="taxpayer-saveBtn"
													type="button"
													onClick={() => setShowKennelWarning(false)}
												>
													Cancel
												</button>
												<button
													className="taxpayer-saveBtn"
													type="button"
													style={{ backgroundColor: "#c0392b" }}
													onClick={() => { setShowKennelWarning(false); handleIssueNewTags() }}
												>
													Continue Anyway
												</button>
											</div>
										</div>
									</div>
								)}
							</fieldset>
							<fieldset className="dtpf-fs-doginfo" disabled={!formTaxpayerId || dogs.some(d => Number(d[1]) < tagYear && !renewalDogIds.has(d[0]))}>
								<legend>Dog Information</legend>
								<StatusPopup message={tagOverrideInfo} />
								<ErrorPopup
									message={tagOverrideError}
									onClose={() => setTagOverrideError("")}
								/>
								<div style={{ color: "gold", marginBottom: "0.25rem" }}>
									Yellow is a required field
								</div>
								<br />
								<table style={{ border: "none" }}>
									<tbody>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_tag_override">Tag# Override:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="text"
													id="dog_tag_override"
													className="f1-input"
													value={tagOverride}
													onFocus={(e) => e.target.select()}
													onChange={(e) => {
														if (/^\d*$/.test(e.target.value))
															setTagOverride(e.target.value)
													}}
													onBlur={(e) => handleTagOverrideBlur(e.target.value)}
													onKeyDown={(e) => {
														if (e.key === "F1") {
															e.preventDefault()
															setShowTagOverrideHelp(true)
														}
													}}
													style={{ width: "8ch" }}
												/>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_tag_status">Tag Status:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												{dogFeeType === "Kennel" ? (
													<select
														id="dog_tag_status"
														value="Kennel"
														onChange={(e) => { if (e.target.value === "Replacement") setDogFeeType("Replacement") }}
													>
														<option value="Kennel" disabled>Kennel</option>
														<option value="Replacement" disabled={!dogTagNumber}>Replacement</option>
													</select>
												) : (
													<select
														id="dog_tag_status"
														value={dogFeeType}
														onChange={(e) => setDogFeeType(e.target.value)}
													>
														<option value="Active">Active</option>
														<option value="Service Dog">Service Dog</option>
														<option value="Replacement" disabled={!dogTagNumber}>Replacement</option>
													</select>
												)}
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_name">Dog Name:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="text"
													id="dog_name"
													value={dogName}
													onFocus={(e) => e.target.select()}
													onChange={(e) => setDogName(title_Case(e.target.value))}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_breed")?.focus()
														}
													}}
												/>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_breed" style={!(dogBreed || "").trim() ? { color: "gold" } : undefined}>Breed:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<div
													style={{
														position: "relative",
														display: "inline-block",
													}}
												>
													<input
														type="text"
														id="dog_breed"
														className="f1-input"
														value={dogBreed}
														autoComplete="off"
														onFocus={(e) => e.target.select()}
														onChange={(e) => {
															const val = e.target.value
															setBreedHighlightIndex(-1)
															if (val === "*") {
																setDogBreed(val)
																setBreedSuggestions(breeds)
																setShowBreedDropdown(breeds.length > 0)
															} else if (val) {
																const filtered = breeds.filter((b) =>
																	b.toLowerCase().startsWith(val.toLowerCase()),
																)
																// Keep the typed text so custom breeds aren't overwritten;
																// highlight a lone match so Enter accepts it in one key.
																setDogBreed(val)
																setBreedSuggestions(filtered)
																setShowBreedDropdown(filtered.length > 0)
																setBreedHighlightIndex(filtered.length === 1 ? 0 : -1)
															} else {
																setDogBreed(val)
																setBreedSuggestions([])
																setShowBreedDropdown(false)
															}
														}}
														onKeyDown={(e) => {
															if (e.key === "F1") {
																e.preventDefault()
																setShowBreedHelp(true)
																return
															}
															if (e.key === "Tab") {
																e.preventDefault()
																if (dogBreed === "*") setDogBreed("")
																setShowBreedDropdown(false)
																setBreedHighlightIndex(-1)
																document.getElementById("dog_size")?.focus()
																return
															}
															if (!showBreedDropdown) return
															if (e.key === "ArrowDown") {
																e.preventDefault()
																setBreedHighlightIndex((i) =>
																	Math.min(i + 1, breedSuggestions.length - 1),
																)
															} else if (e.key === "ArrowUp") {
																e.preventDefault()
																setBreedHighlightIndex((i) =>
																	Math.max(i - 1, 0),
																)
															} else if (
																e.key === "Enter" &&
																breedHighlightIndex >= 0
															) {
																e.preventDefault()
																setDogBreed(
																	breedSuggestions[breedHighlightIndex],
																)
																setShowBreedDropdown(false)
																setBreedHighlightIndex(-1)
																setTimeout(
																	() =>
																		document
																			.getElementById("dog_size")
																			?.focus(),
																	0,
																)
															} else if (e.key === "Escape") {
																if (dogBreed === "*") setDogBreed("")
																setShowBreedDropdown(false)
																setBreedHighlightIndex(-1)
															}
														}}
														onBlur={() =>
															setTimeout(() => {
																if (dogBreed === "*") setDogBreed("")
																setShowBreedDropdown(false)
																setBreedHighlightIndex(-1)
															}, 150)
														}
													/>
													{showBreedDropdown && breedSuggestions.length > 0 && (
														<div
															style={{
																position: "absolute",
																top: "100%",
																left: 0,
																zIndex: 100,
																background: "#fff",
																border: "1px solid #aaa",
																maxHeight: "180px",
																overflowY: "auto",
																minWidth: "100%",
																boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
															}}
														>
															{breedSuggestions.map((b, i) => (
																<div
																	key={b}
																	style={{
																		padding: "3px 8px",
																		cursor: "pointer",
																		background:
																			i === breedHighlightIndex
																				? "#0078d7"
																				: "#fff",
																		color:
																			i === breedHighlightIndex
																				? "#fff"
																				: "inherit",
																	}}
																	onMouseEnter={() => setBreedHighlightIndex(i)}
																	onMouseDown={() => {
																		setDogBreed(b)
																		setShowBreedDropdown(false)
																		setBreedHighlightIndex(-1)
																	}}
																>
																	{b}
																</div>
															))}
														</div>
													)}
												</div>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_size">Size:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<select
													id="dog_size"
													value={dogSize}
													onChange={(e) => setDogSize(e.target.value)}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_age")?.focus()
														}
													}}
												>
													<option value=""></option>
													<option value="TOY">Toy</option>
													<option value="SMALL">Small</option>
													<option value="MEDIUM">Medium</option>
													<option value="LARGE">Large</option>
													<option value="GIANT">Giant</option>
												</select>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_age" style={!(dogAge || "").toString().trim() ? { color: "gold" } : undefined}>Age:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="text"
													id="dog_age"
													value={dogAge}
													style={{ width: "6ch", textAlign: "center" }}
													onFocus={(e) => e.target.select()}
													onChange={(e) => {
														if (/^\d*$/.test(e.target.value))
															setDogAge(e.target.value)
													}}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_sex")?.focus()
														}
													}}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_sex" style={!(dogSex || "").trim() ? { color: "gold" } : undefined}>Sex:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<select
													id="dog_sex"
													value={dogSex}
													onChange={(e) => setDogSex(e.target.value)}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_hair_color")?.focus()
														}
													}}
												>
													<option value="M">M</option>
													<option value="F">F</option>
												</select>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_hair_color" style={!(dogHairColor || "").trim() ? { color: "gold" } : undefined}>Hair Color:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<select
													id="dog_hair_color"
													value={hairColorIsCustom ? "CUSTOM" : dogHairColor}
													onChange={(e) => {
														if (e.target.value === "CUSTOM") {
															setHairColorCustom(true)
															setDogHairColor("")
														} else {
															setHairColorCustom(false)
															setDogHairColor(e.target.value)
														}
													}}
													onKeyDown={(e) => {
														if (e.key === "Tab" && !hairColorIsCustom) {
															e.preventDefault()
															document
																.getElementById("dog_hair_length")
																?.focus()
														}
													}}
												>
													<option value=""></option>
													<option value="BLACK">Black</option>
													<option value="BLACK/TAN">Black/Tan</option>
													<option value="BLACK/WHITE">Black/White</option>
													<option value="BRINDLE">Brindle</option>
													<option value="BLONDE">Blonde</option>
													<option value="BROWN">Brown</option>
													<option value="BROWN/WHITE">Brown/White</option>
													<option value="FAWN">Fawn</option>
													<option value="GRAY">Gray</option>
													<option value="RED">Red</option>
													<option value="TRI-COLOR">Tri-Color</option>
													<option value="WHITE">White</option>
													<option value="CUSTOM">Custom</option>
												</select>
												{hairColorIsCustom && (
													<input
														type="text"
														id="dog_hair_color_custom"
														value={dogHairColor}
														placeholder="Custom color"
														autoComplete="off"
														style={{ marginLeft: "0.5rem", width: "14ch" }}
														onChange={(e) => setDogHairColor(e.target.value.toUpperCase())}
														onKeyDown={(e) => {
															if (e.key === "Tab") {
																e.preventDefault()
																document
																	.getElementById("dog_hair_length")
																	?.focus()
															}
														}}
													/>
												)}
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_hair_length" style={!(dogHairLength || "").trim() ? { color: "gold" } : undefined}>Hair Length:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<select
													id="dog_hair_length"
													value={dogHairLength}
													onChange={(e) => setDogHairLength(e.target.value)}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document
																.getElementById("dog_spay_neuter")
																?.focus()
														}
													}}
												>
													<option value=""></option>
													<option value="HAIRLESS">Hairless</option>
													<option value="SHORT">Short</option>
													<option value="MEDIUM">Medium</option>
													<option value="LONG">Long</option>
												</select>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_spay_neuter">Spay/Neuter:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="checkbox"
													id="dog_spay_neuter"
													checked={dogSpayNeuter}
													onChange={(e) => setDogSpayNeuter(e.target.checked)}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_vicious")?.focus()
														}
													}}
												/>
											</td>
											<td
												style={{
													textAlign: "right",
													border: "none",
													width: "1%",
													whiteSpace: "nowrap",
												}}
											>
												<label htmlFor="dog_vicious">Vicious:</label>
											</td>
											<td style={{ textAlign: "left", border: "none" }}>
												<input
													type="checkbox"
													id="dog_vicious"
													checked={dogVicious}
													onChange={(e) => setDogVicious(e.target.checked)}
													onKeyDown={(e) => {
														if (e.key === "Tab") {
															e.preventDefault()
															document.getElementById("dog_add_btn")?.focus()
														}
													}}
												/>
											</td>
										</tr>
										<tr style={{ backgroundColor: "transparent" }}>
											<td
												colSpan={4}
												style={{
													textAlign: "center",
													border: "none",
													paddingTop: "0.75rem",
												}}
											>
												<button
													className="taxpayer-saveBtn"
													type="button"
													style={{ minWidth: "7rem" }}
													onClick={handleDogClear}
												>
													Clear for Add
												</button>
												{dogAddMode && (
													<button
														id="dog_add_btn"
														className="taxpayer-saveBtn"
														type="button"
														style={{ marginLeft: "0.75rem" }}
														disabled={
															printed ||
															dogStatus === "submitting" ||
															!formTaxpayerId ||
															!(dogBreed || "").trim() ||
															!dogSex ||
															!dogAge.toString().trim() ||
															!dogHairColor.trim() ||
															!dogHairLength.trim() ||
															!!tagOverrideError
														}
														onClick={handleDogAdd}
													>
														Add Dog
													</button>
												)}
												{dogId !== null && (
													<button
														className="taxpayer-saveBtn"
														type="button"
														style={{ marginLeft: "0.75rem" }}
														disabled={
															printed ||
															dogStatus === "submitting" ||
															!(dogBreed || "").trim() ||
															!dogSex ||
															!dogAge.toString().trim() ||
															!dogHairColor.trim() ||
															!dogHairLength.trim()
														}
														onClick={handleDogSave}
													>
														Update Dog
													</button>
												)}
												<ErrorPopup
													message={dogError}
													onClose={() => setDogError("")}
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</fieldset>
						</div>
						<fieldset className="dtpf-fs-receipt">
							<legend>Receipt</legend>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "1.5rem",
									marginBottom: "0.5rem",
								}}
							>
								<div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
									<label style={{ marginRight: "0.25rem", paddingTop: "2px" }}>Method:</label>
									<div style={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}>
										<label htmlFor="pay_cash" className="radio-label" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
											<input
												type="radio"
												id="pay_cash"
												name="paymentMethod"
												value="Cash"
												checked={paymentMethod === "Cash"}
												disabled={printed}
												onChange={() => {
													setPaymentMethod("Cash")
													setDogCheckNumber("")
												}}
											/>
											Cash
										</label>
										<label htmlFor="pay_check" className="radio-label" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
											<input
												type="radio"
												id="pay_check"
												name="paymentMethod"
												value="Check"
												checked={paymentMethod === "Check"}
												disabled={printed}
												onChange={() => setPaymentMethod("Check")}
											/>
											Check
										</label>
										<label htmlFor="pay_online" className="radio-label" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
											<input
												type="radio"
												id="pay_online"
												name="paymentMethod"
												value="Online"
												checked={paymentMethod === "Online"}
												disabled={printed}
												onChange={() => {
													setPaymentMethod("Online")
													setDogCheckNumber("")
												}}
											/>
											Online
										</label>
									</div>
								</div>
								<div>
									<label
										htmlFor="receipt_check_number"
										style={{ marginRight: "0.5rem" }}
									>
										Check #:
									</label>
									<input
										type="text"
										id="receipt_check_number"
										value={dogCheckNumber}
										disabled={printed}
										style={{ width: "50px", textAlign: "center" }}
										onFocus={(e) => e.target.select()}
										onChange={(e) => {
											if (/^\d*$/.test(e.target.value))
												setDogCheckNumber(e.target.value)
										}}
									/>
									<label
										style={{ marginLeft: "1.5rem", marginRight: "0.5rem" }}
									>
										Receipt #:
									</label>
									<input
										type="text"
										value={receiptNumber}
										disabled
										style={{ width: "60px", textAlign: "center" }}
									/>
								</div>
							</div>
							<div className="scroll-table-5">
								<table>
									<thead>
										<tr>
											<th>Item</th>
											<th>Status</th>
											<th>Breed</th>
											<th style={{ textAlign: "center" }}>Qty</th>
											<th>Price</th>
											<th>SubTot</th>
											<th>Total</th>
										</tr>
									</thead>
									<tbody>
										{receipt.map((row, i) => (
											<tr key={i}>
												<td>{row.item}</td>
												<td>{row.status}</td>
												<td>{row.breed}</td>
												<td style={{ textAlign: "center" }}>{row.qty}</td>
												<td style={{ textAlign: "right" }}>
													${row.price.toFixed(2)}
												</td>
												<td style={{ textAlign: "right" }}>
													${row.subtotal.toFixed(2)}
												</td>
												<td style={{ textAlign: "right" }}>
													$
													{receipt
														.slice(0, i + 1)
														.reduce((s, r) => s + r.subtotal, 0)
														.toFixed(2)}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<div
								style={{
									textAlign: "center",
									marginTop: "0.75rem",
									display: "flex",
									gap: "1rem",
									justifyContent: "center",
								}}
							>
								<button
									className="taxpayer-saveBtn"
									type="button"
									style={{ minWidth: "9rem" }}
									disabled={
										printed ||
										!formTaxpayerId ||
										receipt.length === 0 ||
										!IsDeputy ||
										(paymentMethod === "Check" && !dogCheckNumber.trim())
									}
									onClick={handleSaveAndPrint}
								>
									Save &amp; Print
								</button>
								<ErrorPopup message={receiptError} onClose={() => setReceiptError("")} />
							</div>
						</fieldset>
					</div>
				</div>
			</div>

			{showBreedHelp && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)",
						zIndex: 1000,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={() => setShowBreedHelp(false)}
				>
					<div
						style={{
							background: "var(--fieldset-bg, #fff)",
							border: "1px solid #888",
							borderRadius: "6px",
							padding: "1.5rem 2rem",
							maxWidth: "480px",
							width: "90%",
							boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3
							style={{
								marginTop: 0,
								marginBottom: "1rem",
								color: "rgb(60, 60, 60)",
							}}
						>
							Breed — Help
						</h3>
						<p style={{ marginBottom: "0.75rem" }}>
							Start typing the breed name and a drop-down list of matching
							breeds will appear.
						</p>
						<ul style={{ marginBottom: "1rem", paddingLeft: "1.25rem" }}>
							<li style={{ marginBottom: "0.4rem" }}>
								Matching begins from the <strong>first letter</strong> — type
								the first few characters of the breed name to narrow the list.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Type <strong>*</strong> to see all available breeds. The * is
								cleared when you close the list without selecting.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Use the <strong>Up / Down arrow keys</strong> to highlight a
								breed in the list, then press <strong>Enter</strong> to select
								it.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								You can also click any breed in the list to select it.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Press <strong>Escape</strong> to close the drop-down without
								making a selection.
							</li>
							<li>
								If the exact breed is not in the list, type the closest
								description. The breed list is maintained by the system
								administrator — contact them to have a missing breed added.
							</li>
						</ul>
						<div style={{ textAlign: "center" }}>
							<button
								className="taxpayer-saveBtn"
								type="button"
								onClick={() => setShowBreedHelp(false)}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			)}

			{showTagOverrideHelp && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)",
						zIndex: 1000,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={() => setShowTagOverrideHelp(false)}
				>
					<div
						style={{
							background: "var(--fieldset-bg, #fff)",
							border: "1px solid #888",
							borderRadius: "6px",
							padding: "1.5rem 2rem",
							maxWidth: "500px",
							width: "90%",
							boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3
							style={{
								marginTop: 0,
								marginBottom: "1rem",
								color: "rgb(60, 60, 60)",
							}}
						>
							Tag# Override — Help
						</h3>
						<p style={{ marginBottom: "0.75rem" }}>
							Normally the system assigns the next available tag from the
							deputy's own inventory. Use <strong>Tag# Override</strong> to
							specify a particular tag number instead.
						</p>
						<ul style={{ marginBottom: "1rem", paddingLeft: "1.25rem" }}>
							<li style={{ marginBottom: "0.4rem" }}>
								Enter the exact tag number you want assigned to this dog and tab
								out of the field. The system will look up the tag and display
								its status.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								<strong>Assigned</strong> — the tag belongs to a specific
								deputy's inventory. A message will identify that deputy. Obtain
								the physical tag from them before completing the transaction.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								<strong>Unassigned</strong> — the tag exists in the general
								inventory and has not been allocated to any deputy. It can be
								used directly.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								<strong>Active</strong> — the tag has already been issued to a
								dog and cannot be reused. Choose a different tag number.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Any other status (Replacement, Void, etc.) will also be
								rejected. Only Assigned and Unassigned tags are accepted.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								The override is applied at <strong>Save &amp; Print</strong>{" "}
								time, not when the dog is added. The tag will not be marked
								Active until the receipt is saved.
							</li>
							<li>
								Press <strong>Clear</strong> in the Dog Information section to
								remove the override and return to automatic tag assignment.
							</li>
						</ul>
						<div style={{ textAlign: "center" }}>
							<button
								className="taxpayer-saveBtn"
								type="button"
								onClick={() => setShowTagOverrideHelp(false)}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			)}

			{showSgLocked && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)",
						zIndex: 1000,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={() => setShowSgLocked(false)}
				>
					<div
						style={{
							background: "var(--fieldset-bg, #fff)",
							border: "1px solid #888",
							borderRadius: "6px",
							padding: "1.5rem 2rem",
							maxWidth: "420px",
							width: "90%",
							boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
							Any additional sheep or goats must wait until the new fiscal year
							starts on <strong>July 1st</strong>.
						</p>
						<div style={{ textAlign: "center" }}>
							<button
								className="taxpayer-saveBtn"
								type="button"
								onClick={() => setShowSgLocked(false)}
							>
								OK
							</button>
						</div>
					</div>
				</div>
			)}

			{showSgHelp && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)",
						zIndex: 1000,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={() => setShowSgHelp(false)}
				>
					<div
						style={{
							background: "var(--fieldset-bg, #fff)",
							border: "1px solid #888",
							borderRadius: "6px",
							padding: "1.5rem 2rem",
							maxWidth: "480px",
							width: "90%",
							boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3
							style={{
								marginTop: 0,
								marginBottom: "1rem",
								color: "rgb(60, 60, 60)",
							}}
						>
							Sheep &amp; Goats — Help
						</h3>
						<p style={{ marginBottom: "0.75rem" }}>
							Enter the number of sheep and goats owned by the taxpayer for the
							current license year, then press <strong>Save</strong>.
						</p>
						<ul style={{ marginBottom: "1rem", paddingLeft: "1.25rem" }}>
							<li style={{ marginBottom: "0.4rem" }}>
								Enter the count for each animal type. Leave blank or enter{" "}
								<strong>0</strong> if the taxpayer has none of that animal.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								The license fee is calculated per head and added to the receipt
								automatically when saved.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Once a count has been saved for the year it becomes{" "}
								<strong>read-only</strong>. Contact a supervisor if a correction
								is needed.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								The <strong>Save</strong> button is disabled after payment has
								been recorded for this year — the transaction is complete and
								the receipt reflects the final amounts.
							</li>
							<li style={{ marginBottom: "0.4rem" }}>
								Sheep and goats are licensed separately from dogs. They share
								the same receipt and are included in the same{" "}
								<strong>Save &amp; Print</strong> transaction.
							</li>
							<li>
								If both counts are blank when Save is pressed, no livestock fee
								will be added to the receipt.
							</li>
						</ul>
						<div style={{ textAlign: "center" }}>
							<button
								className="taxpayer-saveBtn"
								type="button"
								onClick={() => setShowSgHelp(false)}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			)}

			{showHelp && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)",
						zIndex: 1000,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={() => setShowHelp(false)}
				>
					<div
						style={{
							background: "var(--fieldset-bg, #fff)",
							border: "1px solid #888",
							borderRadius: "6px",
							padding: "1.5rem 2rem",
							maxWidth: "520px",
							width: "90%",
							boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3
							style={{
								marginTop: 0,
								marginBottom: "1rem",
								color: "rgb(60, 60, 60)",
							}}
						>
							Search By — Help
						</h3>
						<p style={{ marginBottom: "0.5rem" }}>
							Type a search value in the <strong>Search By</strong> field and
							press <strong>Enter</strong>. The search type is determined
							automatically:
						</p>
						<table
							style={{
								width: "100%",
								borderCollapse: "collapse",
								marginBottom: "1rem",
							}}
						>
							<thead>
								<tr>
									<th
										style={{
											textAlign: "left",
											paddingBottom: "0.4rem",
											borderBottom: "1px solid #aaa",
										}}
									>
										What you type
									</th>
									<th
										style={{
											textAlign: "left",
											paddingBottom: "0.4rem",
											borderBottom: "1px solid #aaa",
										}}
									>
										Searches by
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td
										style={{
											padding: "0.35rem 0.5rem 0.35rem 0",
											verticalAlign: "top",
										}}
									>
										Digits only, 1–9 digits
										<br />
										<em style={{ fontSize: "0.85em", color: "#666" }}>
											e.g. 201 or 1042
										</em>
									</td>
									<td style={{ padding: "0.35rem 0", verticalAlign: "top" }}>
										Tag number, searched across <strong>all tag years</strong>.
										<br />A tag number is reissued to a different dog each year, so one
										number can belong to several owners over time. A single match loads
										directly; multiple matches show a selection list with the{" "}
										<strong>Year</strong> as the first column - pick the year you want.
									</td>
								</tr>
								<tr>
									<td
										style={{
											padding: "0.35rem 0.5rem 0.35rem 0",
											verticalAlign: "top",
										}}
									>
										Exactly 10 digits
										<br />
										<em style={{ fontSize: "0.85em", color: "#666" }}>
											e.g. 3045551212
										</em>
									</td>
									<td style={{ padding: "0.35rem 0", verticalAlign: "top" }}>
										Phone number (no spaces or dashes)
									</td>
								</tr>
								<tr>
									<td
										style={{
											padding: "0.35rem 0.5rem 0.35rem 0",
											verticalAlign: "top",
										}}
									>
										Contains an @ symbol
										<br />
										<em style={{ fontSize: "0.85em", color: "#666" }}>
											e.g. smith@email.com
										</em>
									</td>
									<td style={{ padding: "0.35rem 0", verticalAlign: "top" }}>
										Email address
									</td>
								</tr>
								<tr>
									<td
										style={{
											padding: "0.35rem 0.5rem 0.35rem 0",
											verticalAlign: "top",
										}}
									>
										A name — any order
										<br />
										<em style={{ fontSize: "0.85em", color: "#666" }}>
											e.g. Smith · John Smith · smi joh
										</em>
									</td>
									<td style={{ padding: "0.35rem 0", verticalAlign: "top" }}>
										Name — first and/or last, in any order, even partial; each word just has to appear in the name.
										<br />A single match loads directly; multiple matches show a
										selection list.
											<br />
											<br />
											<strong>Avoid duplicates:</strong> always search before adding a
											taxpayer. If nothing is found, try a partial name or search by
											phone before adding. If you add someone who may already exist, a{" "}
											<em>Possible Duplicate</em> warning lets you use the existing
											record instead of creating a second one.
									</td>
								</tr>
							</tbody>
						</table>
						<ul
							style={{
								marginTop: 0,
								marginBottom: "1rem",
								paddingLeft: "1.25rem",
							}}
						>
							<li>
								When a tag is <strong>issued</strong>, the tag year is set automatically to
								the current fiscal year (July 1 – June 30) — there is no year to select.
								Searching by tag number is different: it looks at every year.
							</li>
							<li>
								After a search loads a taxpayer, all dogs are shown in{" "}
								<strong>Dogs on File</strong> and any of them may be deleted —
								for example, if the owner no longer has the dog.
							</li>
							<li>
								Deleting a dog added <em>during this session</em> also removes
								it from the receipt. Deleting a previously existing dog does not
								affect the receipt.
							</li>
							<li>
								Press <strong>Clear Page</strong> to reset all fields and start
								a new transaction.
							</li>
						</ul>
						<div style={{ textAlign: "center" }}>
							<button
								className="taxpayer-saveBtn"
								type="button"
								onClick={() => setShowHelp(false)}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</main>
	)
}

export default DogTaxPayerFind
